export { ReactComponent as Website } from "../../assets/romotors-website-icon.svg";

type IconsPropsType = {
  height: string;
  width: string;
  color: string;
  color2?: string;
  direction?: "up" | "down" | "right" | "left";
};

export const Profile = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 20.9 21">
      <path d="M17.9 13.6a10.5 10.5 0 00-4-2.5A6 6 0 107 11a10.5 10.5 0 00-7 9 .8.8 0 00.8.9.8.8 0 00.8-.8 8.9 8.9 0 0117.7 0 .8.8 0 00.8.8.8.8 0 00.8-.9 10.4 10.4 0 00-3-6.5zm-7.4-3.1a4.4 4.4 0 114.4-4.4 4.4 4.4 0 01-4.4 4.4z" />
    </svg>
  );
};

export const Language = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 21 21">
      <path d="M10.5 0A10.5 10.5 0 1021 10.5 10.5 10.5 0 0010.5 0zm2.9 2.1a9 9 0 014.7 4l.2.3h-3.7v-.1A16.7 16.7 0 0013 2.4l-.3-.5zm.1 8.4a7 7 0 01-.2 1.4v.8l-.1.2H7.8v-.5a10.3 10.3 0 010-3.8V8h5.5v.5a12.9 12.9 0 01.2 1.9zm-3.2-8.7l.2-.3.2.3a14.4 14.4 0 012 4.3l.2.3H8l.1-.3a15.8 15.8 0 012-4.3zM2.9 6a9.3 9.3 0 014.7-4l.6-.2-.3.5a16.7 16.7 0 00-1.5 3.9v.1H2.7zm-1 6.6a7.5 7.5 0 010-4.4L2 8h4.2v.3a14.4 14.4 0 00-.2 2.1v1l.1 1.1v.3h-4zM7.7 19a9 9 0 01-4.7-4l-.2-.3h3.7v.1A16.7 16.7 0 008 18.6l.3.5zm2.9.6l-.2-.3a14.5 14.5 0 01-2-4.3l-.2-.3H13l-.1.3a15.8 15.8 0 01-2.1 4.3zm7.6-4.6a9 9 0 01-4.7 4l-.6.2.3-.6a14.8 14.8 0 001.5-3.8v-.1h3.7zm1-2h-4.2v-.3a14.4 14.4 0 00.2-2.1v-1L15 8.3V8h4l.1.2a7.5 7.5 0 010 4.4z" />
    </svg>
  );
};

export const Login = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 20 20">
      <path d="M15.7 10a.8.8 0 01-.2.6l-4 4a.8.8 0 11-1.2-1.2l2.6-2.6H.9a.8.8 0 110-1.6h12l-2.6-2.6a.8.8 0 011.2-1.2l4 4a.8.8 0 01.2.6z" />
      <path d="M20 1.5v17a1.5 1.5 0 01-1.5 1.5H8.6a1.5 1.5 0 01-1.5-1.5V17a.8.8 0 111.7 0v1.2h9.6V1.6H8.8V3A.8.8 0 117 3V1.5A1.5 1.5 0 018.6 0h9.9A1.5 1.5 0 0120 1.5z" />
    </svg>
  );
};

export const Logout = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 20.9 20">
      <path d="M21 10a.8.8 0 01-.3.6l-4 4a.8.8 0 01-1.4-.6.8.8 0 01.2-.6l2.6-2.6H6a.8.8 0 110-1.6h12l-2.5-2.6a.8.8 0 011.2-1.2l4 4a.8.8 0 01.2.6z" />
      <path d="M11.3 3V1.5H1.7v16.7h9.6v-1.2a.8.8 0 011.6 0v1.4a1.5 1.5 0 01-1.5 1.5H1.5A1.5 1.5 0 010 18.5v-17A1.5 1.5 0 011.5 0h10a1.5 1.5 0 011.4 1.5V3a.8.8 0 11-1.6 0z" />
    </svg>
  );
};

export const Car = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 61 27.8">
      <path d="M14.5 27.3a6.2 6.2 0 116.2-6.2 6.2 6.2 0 01-6.2 6.2zm0-10.8a4.6 4.6 0 104.6 4.6 4.6 4.6 0 00-4.6-4.6z" />
      <path d="M14.5 23.8a2.8 2.8 0 112.9-2.8 2.8 2.8 0 01-2.9 2.8zm0-4a1.2 1.2 0 101.3 1.2 1.2 1.2 0 00-1.3-1.2zM47.3 27.3a6.2 6.2 0 116.2-6.2 6.2 6.2 0 01-6.2 6.2zm0-10.8a4.6 4.6 0 104.6 4.6 4.6 4.6 0 00-4.6-4.6z" />
      <path d="M47.3 23.8A2.8 2.8 0 1150 21a2.8 2.8 0 01-2.8 2.8zm0-4a1.2 1.2 0 101.2 1.2 1.2 1.2 0 00-1.2-1.2z" />
      <path d="M60 21.8h-4.3a.8.8 0 01-.8-.8h0a.8.8 0 01.8-.8h3l.2-1.9a2.4 2.4 0 00-1-2.2l-.1-.2-.2-.3c-.9-2-3-4.4-5.5-5L41 7.6a1 1 0 01-.2 0L33.5 4c-2-1.2-5.6-1.9-9.5-1.9h-6.9c-2.3 0-5.7 2.4-7.6 4.7a9.6 9.6 0 01-2.6 2.1l-3.3 2A2.8 2.8 0 002 13.2v3.6c0 1.5 2 3 3.7 3.3a.8.8 0 01.7.8h0a.8.8 0 01-.9.8h-.2C2.9 21.4.5 19.3.5 17v-3.6a4.5 4.5 0 012.3-3.9L6 7.5a8 8 0 002.1-1.7c2.3-2.7 6-5.3 9-5.3H24c2 0 7 .2 10.2 2l7.2 3.6a.8.8 0 00.2 0L52.5 9a11 11 0 016.5 5.9 4 4 0 011.5 3.6z" />
      <path d="M37.5 10H19a.8.8 0 01-.8-.7h0a.8.8 0 01.8-.8H35v-.2l-3.3-1.6a16.5 16.5 0 00-7.5-1.5h-5.3c-1.6 0-4 1.5-5.5 3.2h.4a.8.8 0 01.8.9h0a.8.8 0 01-.8.8H13a.5.5 0 01-.4-.2l-1.2-1.1a.5.5 0 010-.7l.1-.2c1.8-2.1 5-4.3 7.3-4.3h5.3c1.6 0 5.6.2 8.3 1.7L38.2 8a.5.5 0 01.2.6l-.4 1a.6.6 0 01-.5.4z" />
      <g transform="translate(22.5 20.2)">
        <rect width="16.8" height="1.6" rx=".8" />
      </g>
      <g>
        <path d="M58.2 16l-4.1-.8a4 4 0 01-2.4-1.6l-.4-.7a.8.8 0 01.2-1h0a.8.8 0 011 .1l.5.6a2.4 2.4 0 001.4 1l4.2 1z" />
      </g>
    </svg>
  );
};

export const Bus = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 228.000000 110.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M248 1080 c-10 -16 -24 -20 -65 -20 -68 0 -99 -13 -118 -49 -23 -46
-44 -260 -51 -521 -4 -129 -9 -254 -11 -278 -4 -29 0 -50 11 -67 16 -25 18
-25 161 -25 85 0 146 -4 150 -10 3 -5 16 -10 28 -10 16 0 26 -9 34 -30 28 -73
152 -94 213 -35 16 16 32 36 35 44 11 37 68 41 584 41 323 0 502 -4 506 -10 3
-5 16 -10 28 -10 15 0 28 -11 40 -33 24 -44 65 -67 119 -67 53 0 101 28 119
69 10 21 21 31 36 31 12 0 26 6 30 14 5 9 33 15 77 18 95 6 106 21 106 137 -1
60 -5 92 -15 105 -8 11 -15 33 -15 49 0 40 -34 97 -77 127 -19 14 -60 52 -91
85 -122 130 -221 224 -312 296 -169 133 -138 121 -339 127 -157 4 -177 7 -189
23 -12 18 -37 19 -497 19 -474 0 -485 0 -497 -20z m1427 -117 l90 -68 -120 -2
c-66 -2 -447 -4 -848 -5 l-727 -3 0 25 c0 42 20 99 38 109 11 7 280 11 747 11
l730 0 90 -67z m-1601 -185 c-4 -46 -10 -103 -14 -128 l-8 -45 -1 60 c-1 86
10 195 21 195 6 0 7 -34 2 -82z m356 -48 l0 -130 -176 0 -177 0 7 92 c3 50 6
108 6 130 l0 38 170 0 170 0 0 -130z m410 5 l0 -125 -122 0 c-68 0 -153 -3
-190 -7 l-68 -6 0 132 0 131 190 0 190 0 0 -125z m390 0 l0 -125 -180 0 -180
0 0 125 0 125 180 0 180 0 0 -125z m32 23 c-4 -151 -9 -160 -11 -20 0 67 3
122 7 122 4 0 6 -46 4 -102z m310 -18 l-3 -120 -145 0 -144 0 0 120 0 120 148
0 147 0 -3 -120z m30 23 c-4 -150 -9 -161 -11 -25 0 67 2 122 7 122 4 0 6 -44
4 -97z m142 -15 c10 -62 21 -125 24 -140 4 -26 2 -28 -29 -28 -19 0 -40 4 -47
8 -11 8 -42 132 -56 230 l-6 42 48 0 48 0 18 -112z m170 10 c97 -91 106 -103
87 -110 -15 -5 -21 -16 -21 -38 l0 -31 -87 3 -87 3 -23 110 c-13 61 -26 122
-30 138 -5 25 -3 27 24 27 23 0 51 -21 137 -102z m-240 -201 c14 -8 65 -11
164 -9 116 2 142 0 142 -12 0 -34 50 -26 96 16 l21 19 11 -56 c7 -31 24 -76
40 -99 l29 -42 -23 -17 c-13 -10 -25 -33 -29 -57 -6 -34 -11 -40 -31 -40 -13
0 -24 5 -24 11 0 5 -21 19 -47 31 -38 17 -61 20 -129 16 -70 -4 -87 -8 -117
-31 -29 -22 -46 -27 -91 -27 l-56 0 1 193 c1 148 3 183 11 154 6 -20 20 -43
32 -50z m-74 -45 l0 -77 -45 3 c-43 4 -45 3 -45 -23 0 -26 2 -27 45 -23 l45 3
0 -85 0 -85 -169 0 -169 0 -4 175 c-3 96 -3 178 -1 183 2 4 80 7 174 7 l169 0
0 -78z m-883 58 l513 0 0 -27 0 -28 -203 -3 c-111 -2 -206 -7 -211 -12 -5 -5
-6 -16 -3 -24 6 -14 34 -16 212 -16 l205 0 0 -97 0 -98 -279 0 c-247 0 -281 2
-297 17 -31 27 -71 38 -145 38 -73 0 -124 -15 -148 -43 -11 -15 -36 -17 -167
-17 l-154 0 0 144 c0 79 3 152 7 162 5 14 16 16 81 10 41 -3 306 -6 589 -6z
m1489 -112 c8 -15 14 -37 14 -49 0 -22 0 -22 -21 -3 -22 20 -51 72 -64 114 -7
25 -7 25 25 -5 17 -16 38 -42 46 -57z m-633 -45 c-7 -2 -21 -2 -30 0 -10 3 -4
5 12 5 17 0 24 -2 18 -5z m-984 -136 c43 -15 69 -50 77 -104 5 -35 4 -43 -8
-43 -10 0 -18 14 -22 39 -10 66 -91 114 -161 97 -41 -10 -94 -64 -101 -102 -3
-19 -12 -34 -20 -34 -17 0 -17 -4 1 56 16 55 47 90 85 97 48 8 115 6 149 -6z
m1423 -2 c26 -10 48 -50 55 -100 7 -51 -11 -64 -22 -15 -9 43 -49 87 -91 100
-74 25 -155 -18 -174 -91 -6 -22 -17 -39 -25 -39 -12 0 -12 7 0 45 19 65 40
93 78 104 33 11 148 8 179 -4z m-1468 -98 c21 -16 24 -60 6 -82 -16 -20 -64
-19 -84 1 -22 21 -20 50 4 74 23 23 49 26 74 7z m1410 -9 c20 -29 20 -47 -1
-70 -23 -25 -68 -23 -87 4 -20 29 -20 30 5 62 25 32 62 34 83 4z"
        />
        <path
          d="M1690 465 c0 -42 2 -46 23 -43 19 3 22 9 22 43 0 34 -3 40 -22 43
-21 3 -23 -1 -23 -43z m27 3 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z"
        />
      </g>
    </svg>
  );
};

export const Motorcycle = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 52 33.6">
      <path d="M52 23.5a3.4 3.4 0 00-.4-1 11.8 11.8 0 00-7.9-6 5.8 5.8 0 00.4-4c-.3-1.4-.8-2.6-1-4a2.3 2.3 0 01-.1-1 3.2 3.2 0 01.7-1 5.6 5.6 0 001-3.1 5 5 0 00-.8-3.1c-.3-.4-.7-.3-1.1-.2l-2 .5-4 1.2-.3.2v.8l-1.9.6a1.1 1.1 0 00.2 2.1l1.7.3v.7l2.7 1.4c-2.3.6-3.7 2.7-4.5 4.9s-.9 4.5-1.4 6.7a1.9 1.9 0 01-.6 1.1 2 2 0 01-1 .3h-2.1c-1.8.2-3.8.2-5.3-.9a3.2 3.2 0 01-1.2-1.7c-.5-1.7.5-2.7 1.5-3.6a55.1 55.1 0 014.1-3.6c.4-.3.8-.7.5-1.2a7.4 7.4 0 00-4.5-3.2 15.8 15.8 0 00-5.7-.3 2.8 2.8 0 00-1.7.5c-.9.8-.5 2.3 0 3.5a30.8 30.8 0 00-11.6 6C2.4 19.1 0 23.3 0 27.6a1.2 1.2 0 00.3 1 1.2 1.2 0 00.8.2h2.7a6.6 6.6 0 0012.6-.2 118.8 118.8 0 0021.2-1.5 6.7 6.7 0 1012.9-2.5c.3.4 1.2.1 1.4-.5a1.4 1.4 0 000-.7zM24.7 8.2a5 5 0 011.4.5.8.8 0 01.5.5 1 1 0 010 .7c-.2.3-1 .3-1.3.3h-6a1 1 0 01-1-1v-.4c0-.4.2-.9.5-1a1.8 1.8 0 01.5 0h1a19.3 19.3 0 014.4.4zM10.1 32a5 5 0 01-4.5-3.1h9a5 5 0 01-4.5 3zm23.5-6.5a13 13 0 01-1.3.5 14 14 0 01-3.7.6l-11.9.6h-14a.9.9 0 01-.9-1C2.4 22 5 18.5 9.6 15.6a30.7 30.7 0 018-3.5H25l-3.3 3c-.2 0-.4.2-.6.4-.2.2-.1.5 0 .8.2 2 .7 4.5 2.5 5.7a5.3 5.3 0 002.8.7h4.9a4.5 4.5 0 001.1-.2 3.3 3.3 0 002.4-2.4l.4-2c.5-3.1 1.4-8.5 4.6-8.5h.4a.4.4 0 00.4-.5l-.2-1-.2-.7a1.9 1.9 0 00-.1-.6 1.1 1.1 0 00-.5-.4L38 5.5a.5.5 0 01-.3-.4V3.6A.5.5 0 0138 3l4.1-1a.3.3 0 01.3.2l.6 2.9a.2.2 0 01-.1.2l-1 .9a1.1 1.1 0 00-.3 1l1 7.2A24.7 24.7 0 0141 18a27 27 0 01-1.7 2.6 15.9 15.9 0 01-4.4 4 13.4 13.4 0 01-1.3.9zM44.2 32a5 5 0 01-4.9-4.6l2.4-2.5a.7.7 0 01.4-.2 3 3 0 00-.8 2.1 3 3 0 105.8 0 3 3 0 00-.8-2.1h2.4a5.4 5.4 0 01.4 2.1 5 5 0 01-4.9 5.2zm1.3-5.2a1.3 1.3 0 11-1.3-1.4 1.4 1.4 0 011.3 1.4zm-4-3.8a.7.7 0 00-.5.2l-1.1 1.1-1.4 1.5h-1.7l1-1a21.9 21.9 0 003-3.2 23.5 23.5 0 002-3.4 8.9 8.9 0 012.8.7 9.1 9.1 0 014.2 4z" />
      <path d="M10.6 21h3.8a.9.9 0 000-1.6h-3.8a.9.9 0 100 1.7zM16 22.7H9a.9.9 0 100 1.7h7a.9.9 0 100-1.7z" />
    </svg>
  );
};

export const Truck = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 53.6 36.4">
      <path d="M53.3 13.1l-2.4-6a3.4 3.4 0 00-3.1-2.3H34.5a.8.8 0 00-.8.8v20.2a.8.8 0 00.8.8h6l-.7.8a5.5 5.5 0 00-1 2v.5h-9.5v-.4a5.6 5.6 0 00-1-2l-.6-.8h2.1a.8.8 0 100-1.6h-7l-1.6-9a.8.8 0 00-.9-.7.8.8 0 00-.7 1l1.6 8.7h-7.8l-1.6-9a.8.8 0 00-.9-.7.8.8 0 00-.5.3.8.8 0 00-.2.6l1.6 8.8H5.4l-.4-.3L1.7 9.1H26a1 1 0 001-.6l3.4-6.9H38a.8.8 0 100-1.6h-8.5l-3.2 6.3a2 2 0 01-1.8 1.2H1.2a1.3 1.3 0 00-.7.2A1.2 1.2 0 000 8.9l3.4 16a2.2 2.2 0 002.1 1.8H7l-.6.9a5.5 5.5 0 00-1 3.7 5.6 5.6 0 0011 .7v-.4h2l.1.4a5.6 5.6 0 0010.9 0v-.5h9.4v.4a5.6 5.6 0 1010-4.5l-.7-.8h3.2a2.4 2.4 0 002.4-2.4v-9.7a3.8 3.8 0 00-.3-1.4zM10.8 34.8a4 4 0 114-4 4 4 0 01-4 4zm7.6-5.2l-.1.4h-2v-.4a5.5 5.5 0 00-1-2l-.5-.9h5.1l-.6.9a5.5 5.5 0 00-1 2zm5.4 5.2a4 4 0 114-4 4 4 0 01-4 4zm24.4-4a4 4 0 11-4-4 4 4 0 014 4zm3.7-6.6a.8.8 0 01-.7.7h-16V6.4h4.1v9a.2.2 0 00.2.1l12.4 2.8zm0-7.6l-10.4-2.3a.8.8 0 01-.6-.7V6.4h6.9a1.8 1.8 0 011.6 1.2l2.4 6a2.2 2.2 0 01.2 1z" />
      <path d="M10.8 28a2.8 2.8 0 102.8 2.8 2.8 2.8 0 00-2.8-2.7zm0 4a1.1 1.1 0 111.2-1.2 1.1 1.1 0 01-1.2 1.1zM23.8 28a2.8 2.8 0 102.8 2.8 2.8 2.8 0 00-2.8-2.7zm0 4a1.1 1.1 0 111.1-1.2 1.1 1.1 0 01-1 1.1zM44.2 28a2.8 2.8 0 102.8 2.8 2.8 2.8 0 00-2.8-2.7zm0 4a1.1 1.1 0 111.1-1.2 1.1 1.1 0 01-1 1.1z" />
    </svg>
  );
};

export const Chevron = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 7.9 13.2">
      <path d="M7.6 6L1.6.3a.7.7 0 00-1 0L.3.6a.7.7 0 000 1l5 5-5 5a.7.7 0 000 1l.5.4a.7.7 0 001 0l6-5.9a.7.7 0 000-1z" />{" "}
    </svg>
  );
};

export const Plus = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 25 25">
      <path d="M20.3 12.5a1 1 0 01-1 1h-5.8v5.8a1 1 0 11-2 0v-5.8H5.7a1 1 0 010-2h5.8V5.7a1 1 0 112 0v5.8h5.8a1 1 0 011 1z" />
      <path d="M12.5 0A12.5 12.5 0 1025 12.5 12.5 12.5 0 0012.5 0zm0 23a10.4 10.4 0 1110.4-10.5 10.4 10.4 0 01-10.4 10.4z" />{" "}
    </svg>
  );
};

export const Minus = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 21 21">
      <path d="M16.3 11.2H4.8a.7.7 0 0 1 0-1.3h11.5a.7.7 0 0 1 0 1.3Z" />
      <path d="M10.5 21A10.5 10.5 0 1 1 21 10.5 10.5 10.5 0 0 1 10.5 21Zm0-19.6a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9.1-9.1Z" />{" "}
    </svg>
  );
};

export const Check = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 19.8 15.6">
      <path d="M7.1 15.6A1.6 1.6 0 016 15L.5 9.6a1.6 1.6 0 010-2.3L1.8 6A1.6 1.6 0 014 6l3 3L15.8.6a1.6 1.6 0 012.2 0l1.3 1.3a1.6 1.6 0 010 2.3l-11 11a1.6 1.6 0 01-1.2.5zm.7-1zM2.9 7a.2.2 0 00-.2 0L1.4 8.4a.2.2 0 000 .3L7 14.1a.2.2 0 00.3 0l11-11a.2.2 0 000-.4l-1.2-1.3a.2.2 0 00-.4 0l-9 9.1a.7.7 0 01-1 0L3 7a.2.2 0 00-.2 0z" />{" "}
    </svg>
  );
};

export const XMark = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 24.3 24.4">
      <path d="M17.6 12.1 24 6a1.4 1.4 0 0 0 0-2L20.3.5a1.4 1.4 0 0 0-2 0l-6.2 6.2L6 .4a1.4 1.4 0 0 0-2 0L.5 4a1.4 1.4 0 0 0 0 1.9L6.6 12 .4 18.4a1.4 1.4 0 0 0 0 1.9L4 23.8a1.4 1.4 0 0 0 1.9 0l6.2-6.2 6.5 6.5a1 1 0 0 0 .7.3 1 1 0 0 0 .7-.3l3.9-3.8a1.4 1.4 0 0 0 0-2Zm-9 1a1.4 1.4 0 0 0 0-2L2.3 5 5 2.3l6.3 6.2a1.4 1.4 0 0 0 1.9 0l6.2-6.2L22 5l-6.2 6.3a1.3 1.3 0 0 0 0 1.9l6.2 6.2-2.6 2.6-6.5-6.5a1 1 0 0 0-1.4 0L5 22l-2.6-2.6Z" />
    </svg>
  );
};

export const Close = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 22.2 22.2">
      <path d="M21.8.4a1.3 1.3 0 010 1.8l-8.9 8.9 8.9 8.8a1.3 1.3 0 01-1.9 1.9l-8.8-8.9-8.9 8.9a1.3 1.3 0 11-1.8-1.9l8.8-8.8L.4 2.2A1.3 1.3 0 012.2.4l8.9 8.8L19.9.4a1.3 1.3 0 011.9 0z" />{" "}
    </svg>
  );
};

export const Share = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 23 25">
      <path d="M22.5 19.3a3.8 3.8 0 0 0-5.2-1.4 3.7 3.7 0 0 0-1 .9l-8.8-5a3.8 3.8 0 0 0 0-1.7l9.3-5.4a3.8 3.8 0 1 0-1.4-2.9 3.7 3.7 0 0 0 .3 1.4l-9 5a3.8 3.8 0 1 0-.2 5.2l9 5.2a3.8 3.8 0 0 0 2.7 4.3 3.8 3.8 0 0 0 4.7-2.7 3.8 3.8 0 0 0-.4-3ZM21 21.7a1.9 1.9 0 1 1-2.7-2.1 1.9 1.9 0 0 1 .9-.3 2 2 0 0 1 .5 0 1.9 1.9 0 0 1 1.3 2.4ZM17.3 3.8a1.9 1.9 0 1 1 2 1.9 1.9 1.9 0 0 1-2-1.9ZM5.7 12.6a1.9 1.9 0 0 1-.2 1h-.1v.1a1.9 1.9 0 1 1 .3-1Z" />{" "}
    </svg>
  );
};

export const Warning = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 28.4 25.1">
      <path d="M13 20.4a1 1 0 0 1 1-1.2 1.1 1.1 0 0 1 0 2.3 1 1 0 0 1-1-1v-.1Zm.4-3-.2-8.3a.3.3 0 0 1 .2-.3h1.3a.3.3 0 0 1 .2.3l-.2 8.4a.3.3 0 0 1-.3.2h-.7a.3.3 0 0 1-.3-.2Z" />
      <path d="M2 25a2 2 0 0 1-1.7-3L12.4 1A2 2 0 0 1 16 1L28 22a2 2 0 0 1-.7 2.8 2 2 0 0 1-1 .3H2Zm24.3-2.3Zm-23.6 0h23l-11.5-20ZM14.5 2.2Z" />{" "}
    </svg>
  );
};

export const Success = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 141 141.4">
      <g>
        <path d="M136 18.5a6 6 0 0 0-8.5 0L61.7 84.4h-1a2.3 2.3 0 0 1-1.7-.7L39.3 64a6 6 0 1 0-8.5 8.5L57.2 99a4.9 4.9 0 0 0 7 0L136 27a6 6 0 0 0 0-8.5Z" />
        <path d="M139.7 74.4a5.4 5.4 0 0 0-4-1.8 5.3 5.3 0 0 0-5.4 4.7 59.7 59.7 0 1 1-47-65.3 5.3 5.3 0 0 0 6.2-6.7 5.2 5.2 0 0 0-4-3.6A72.4 72.4 0 0 0 70.8 0 70.9 70.9 0 0 0 19 22.6 70 70 0 0 0 .2 75.8 70.7 70.7 0 0 0 141 78.5a5.3 5.3 0 0 0-1.3-4.1Z" />
      </g>
    </svg>
  );
};

export const Heart = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 26.9 25">
      <path d="M22.6.7C21.6.2 18-1.1 14 2l-.7.5-.7-.5A8.6 8.6 0 0 0 7.3 0a7.2 7.2 0 0 0-3 .7C1.3 2-1.1 6.2.5 12c2.1 7.7 10.6 13 13 13s10.7-5.3 12.8-13C28 6 25.6 2 22.6.7Zm1.2 10.8a19.5 19.5 0 0 1-9.3 10.8 2.3 2.3 0 0 1-1 .2 2.3 2.3 0 0 1-1-.2c-2.2-1-7.8-5-9.5-10.8-1.2-4.7.4-7.8 2.5-8.8a4 4 0 0 1 1.8-.4c1.7 0 3.5 1 5.1 2.8a1.3 1.3 0 0 0 1 .5 1.4 1.4 0 0 0 1-.5c2.3-2.5 4.9-3.4 7-2.4 2 1 3.7 4.1 2.4 8.7Z" />
    </svg>
  );
};

export const HeartFilled = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 26.9 25">
      <path d="M22.6.7C21.6.2 18-1.1 14 2l-.7.5-.7-.5A8.6 8.6 0 0 0 7.3 0a7.2 7.2 0 0 0-3 .7C1.3 2-1.1 6.2.5 12c2.1 7.7 10.6 13 13 13s10.7-5.3 12.8-13C28 6 25.6 2 22.6.7Z" />{" "}
    </svg>
  );
};

export const Facebook = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 54.1 54.1">
      <path
        fill="#337fff"
        d="M54.1 27a27 27 0 1 0-31.3 26.8v-19H16v-7.7h6.8v-6c0-6.8 4-10.5 10.2-10.5a41.5 41.5 0 0 1 6.1.5v6.7h-3.4c-3.4 0-4.4 2-4.4 4.2v5h7.5L37.6 35h-6.3v18.9A27 27 0 0 0 54 27Z"
      />
      <path
        fill="#fff"
        d="m37.6 34.9 1.2-7.8h-7.5V22c0-2.2 1-4.2 4.4-4.2h3.4V11a41.5 41.5 0 0 0-6-.5c-6.2 0-10.3 3.7-10.3 10.5v6H16v7.8h6.8v18.9a27.3 27.3 0 0 0 8.5 0v-19Z"
      />
    </svg>
  );
};

export const Instagram = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 54.1 54.1">
      <defs>
        <linearGradient id="a" x1="0" x2="1" y1=".1" y2=".9" gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#fbe18a" />
          <stop offset=".2" stopColor="#fcbb45" />
          <stop offset=".4" stopColor="#f75274" />
          <stop offset=".5" stopColor="#d53692" />
          <stop offset=".7" stopColor="#8f39ce" />
          <stop offset="1" stopColor="#5b4fe9" />
        </linearGradient>
      </defs>
      <circle cx="27.1" cy="27.1" r="27.1" fill="url(#a)" />
      <g fill="#fff">
        <path d="M35.5 16.8a1.9 1.9 0 1 0 1.8 1.9 1.9 1.9 0 0 0-1.8-1.9ZM27.2 19.2A7.8 7.8 0 1 0 35 27a7.8 7.8 0 0 0-7.8-7.8Zm0 12.8a5 5 0 1 1 5-5 5 5 0 0 1-5 5Z" />
        <path d="M33.4 42.9H20.7a9.5 9.5 0 0 1-9.5-9.6V20.7a9.5 9.5 0 0 1 9.5-9.5h12.7a9.5 9.5 0 0 1 9.5 9.5v12.7a9.5 9.5 0 0 1-9.5 9.5ZM20.7 14a6.6 6.6 0 0 0-6.5 6.6v12.6a6.6 6.6 0 0 0 6.5 6.6h12.7a6.6 6.6 0 0 0 6.5-6.6V20.7a6.6 6.6 0 0 0-6.5-6.6Z" />
      </g>{" "}
    </svg>
  );
};

export const Youtube = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 54.1 54.1">
      <circle cx="27.1" cy="27.1" r="27.1" fill="red" />
      <path
        fill="#fff"
        d="M41.5 23.2a6.5 6.5 0 0 0-6.5-6.5H18.4a6.5 6.5 0 0 0-6.5 6.5v7.7a6.5 6.5 0 0 0 6.5 6.5H35a6.5 6.5 0 0 0 6.5-6.5Zm-9.7 4.4-7.5 3.7c-.3.2-1.3 0-1.3-.4v-7.5c0-.4 1-.6 1.3-.4l7.2 3.9c.3.1.6.6.3.7Z"
      />
    </svg>
  );
};

export const Menu = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 34 34">
      <image
        width="34"
        height="34"
        xlinkHref="data:image/png;base64,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"
      />
    </svg>
  );
};

export const Tick = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 28 19">
      <path d="M10.5 19a1.7 1.7 0 01-1.3-.5 1.7 1.7 0 01-.2-.3L.5 9.8a1.7 1.7 0 010-2.4 1.8 1.8 0 012.5 0l7.5 7.4L25.1.5a1.8 1.8 0 012.4 0 1.7 1.7 0 010 2.4L12 18.2a1.7 1.7 0 01-1.5.8z" />
    </svg>
  );
};

export const FacebookIcon = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 16.9 33.8">
      <path d="M16.9 6.3h-4.2a2 2 0 0 0-2.1 2.1v4.3h6.3V19h-6.3v14.8H4.2V19H0v-6.3h4.2V7.4A7.5 7.5 0 0 1 11.6 0H17Z" />
    </svg>
  );
};

export const GoogleIcon = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 29.9 30.8">
      <path d="M8.8 30.8C3 30.8 0 27.5 0 24.4a5.7 5.7 0 0 1 3.2-5.2 14.3 14.3 0 0 1 6.6-1.9 2.8 2.8 0 0 1-.6-2.1 2 2 0 0 1 .2-1.1h-.9a6.8 6.8 0 0 1-5-2 6.4 6.4 0 0 1-1.8-4.4 7.5 7.5 0 0 1 2.1-5.2A9 9 0 0 1 10.5 0h9l-.7.6-1.5 1.5-.2.3h-1.5a6.4 6.4 0 0 1 2 4.7c0 2.9-1.5 4.4-3.5 5.7a1.8 1.8 0 0 0-.9 1.5 1.4 1.4 0 0 0 .9 1.3 4.6 4.6 0 0 0 1 .6l.4.3c1.7 1.2 3.7 2.7 3.7 6A7.7 7.7 0 0 1 17 28a11.4 11.4 0 0 1-8.1 2.8Zm2.5-11.6a15.7 15.7 0 0 0-3.8.7c-1 .2-3.2 1.1-3.2 3.6a4.2 4.2 0 0 0 1.6 3.2 7.5 7.5 0 0 0 4.8 1.5c3.2 0 5.1-2.2 5.1-4.3 0-1.5-1-2.5-3.8-4.7ZM8.8 2.4C8 2.4 6 2.6 6 6a8.6 8.6 0 0 0 1 4 3.8 3.8 0 0 0 3.3 2.2 3.3 3.3 0 0 0 3-3.4 9.1 9.1 0 0 0-1-4 4 4 0 0 0-3.5-2.4Z" />
      <path d="M29.9 15.4h-4.3v4.2h-2.1v-4.2h-4.3v-2.2h4.3V9h2.1v4.2H30v2.2Z" />
    </svg>
  );
};

export const AddImage = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 85.9 79.7">
      <path d="M83.7 62.4H73V51.6a2.2 2.2 0 0 0-4.4 0v10.8H57.8a2.2 2.2 0 1 0 0 4.3h10.8v10.8a2.2 2.2 0 1 0 4.4 0V66.7h10.7a2.2 2.2 0 0 0 0-4.3ZM23 12.4a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8ZM73.4 0H12.5A12.6 12.6 0 0 0 0 12.6v48.3a12.6 12.6 0 0 0 12.5 12.6h32.9A2.2 2.2 0 0 0 47 70l-9.6-12.5L64 23.6l17.5 20.9v6.2a2.2 2.2 0 1 0 4.3 0V12.6A12.6 12.6 0 0 0 73.4 0Zm8.2 37.6L65.7 18.8A2.2 2.2 0 0 0 64 18a2.2 2.2 0 0 0-1.7.8L34.7 54l-10-13a2.2 2.2 0 0 0-3.5 0l-7.6 10a2.2 2.2 0 0 0 .4 3 2.2 2.2 0 0 0 1.6.4 2.2 2.2 0 0 0 1.5-.8l5.8-7.6L41 69H12.5A8.2 8.2 0 0 1 4.4 61V12.6a8.2 8.2 0 0 1 8.1-8.2h60.9a8.2 8.2 0 0 1 8.2 8.2ZM22.9 12.4a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Zm0-13.9a9.1 9.1 0 1 0 9.1 9.1 9.1 9.1 0 0 0-9-9Zm0 13.9a4.7 4.7 0 1 1 4.7-4.8 4.7 4.7 0 0 1-4.7 4.8Z" />
    </svg>
  );
};

export const FB = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 39.6 39.6">
      <g>
        <path d="M19.8 39.6a19.8 19.8 0 1 1 19.8-19.8 19.8 19.8 0 0 1-19.8 19.8Zm0-38.1A18.3 18.3 0 1 0 38 19.8 18.3 18.3 0 0 0 19.8 1.5Z" />
        <path d="M16.9 31.3h4.6V19.7h3.2l.4-3.9h-3.6v-2.2c0-1 .2-1.3 1-1.3h2.6v-4h-3.2c-3.5 0-5 1.5-5 4.4v3.1h-2.4v4h2.4Z" />
      </g>
    </svg>
  );
};

export const TW = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 39.6 39.6">
      <g>
        <path d="M19.8 39.6a19.8 19.8 0 1 1 19.8-19.8 19.8 19.8 0 0 1-19.8 19.8Zm0-38.1A18.3 18.3 0 1 0 38 19.8 18.3 18.3 0 0 0 19.8 1.5Z" />
        <path d="M9.6 26.2a11.8 11.8 0 0 0 18.2-10.6 8.5 8.5 0 0 0 2.1-2.1 8.3 8.3 0 0 1-2.4.6 4.2 4.2 0 0 0 1.9-2.3 8.3 8.3 0 0 1-2.7 1 4.2 4.2 0 0 0-7 3.9 11.8 11.8 0 0 1-8.6-4.4 4.2 4.2 0 0 0 1.2 5.6 4.1 4.1 0 0 1-1.8-.6 4.2 4.2 0 0 0 3.3 4.2 4.2 4.2 0 0 1-1.9 0 4.2 4.2 0 0 0 3.9 3 8.4 8.4 0 0 1-6.2 1.7Z" />
      </g>
    </svg>
  );
};

export const YT = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 39.6 39.6">
      <g>
        <path d="M19.8 39.6a19.8 19.8 0 1 1 19.8-19.8 19.8 19.8 0 0 1-19.8 19.8Zm0-38.1A18.3 18.3 0 1 0 38 19.8 18.3 18.3 0 0 0 19.8 1.5Z" />
        <path d="M33 13.1a3.5 3.5 0 0 0-2.5-2.4c-2.1-.6-10.7-.6-10.7-.6s-8.6 0-10.8.6A3.5 3.5 0 0 0 6.6 13a39 39 0 0 0 0 13.3A3.5 3.5 0 0 0 9 29c2.2.6 10.8.6 10.8.6s8.6 0 10.7-.6a3.5 3.5 0 0 0 2.5-2.5 39 39 0 0 0 0-13.3ZM17 24v-8.2l7.2 4Z" />
      </g>{" "}
    </svg>
  );
};

export const IG = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 39.6 39.6">
      <g>
        <path d="M19.8 39.6a19.8 19.8 0 1 1 19.8-19.8 19.8 19.8 0 0 1-19.8 19.8Zm0-38.1A18.3 18.3 0 1 0 38 19.8 18.3 18.3 0 0 0 19.8 1.5Z" />
        <path d="M19.8 11.2H24a5.8 5.8 0 0 1 2 .4 3.5 3.5 0 0 1 2 2 5.8 5.8 0 0 1 .3 2 72.5 72.5 0 0 1 0 8.4 5.8 5.8 0 0 1-.4 2 3.5 3.5 0 0 1-2 2 5.8 5.8 0 0 1-1.9.3 73 73 0 0 1-8.4 0 5.8 5.8 0 0 1-2-.4 3.5 3.5 0 0 1-2-2 5.8 5.8 0 0 1-.3-1.9 72.5 72.5 0 0 1 0-8.4 5.8 5.8 0 0 1 .3-2 3.5 3.5 0 0 1 2-2 5.8 5.8 0 0 1 2-.3h4.2m0-2a75 75 0 0 0-4.3.1 7.7 7.7 0 0 0-2.6.5 5.3 5.3 0 0 0-3 3 7.6 7.6 0 0 0-.5 2.6 73.7 73.7 0 0 0 0 8.6 7.6 7.6 0 0 0 .5 2.5 5.3 5.3 0 0 0 3 3 7.7 7.7 0 0 0 2.6.5 74 74 0 0 0 8.6 0 7.7 7.7 0 0 0 2.5-.4 5.3 5.3 0 0 0 3-3 7.7 7.7 0 0 0 .5-2.6 73.7 73.7 0 0 0 0-8.6 7.7 7.7 0 0 0-.4-2.6 5.3 5.3 0 0 0-3-3 7.7 7.7 0 0 0-2.6-.5 75 75 0 0 0-4.3 0" />
        <path d="M19.8 14.4a5.4 5.4 0 1 0 5.3 5.4 5.4 5.4 0 0 0-5.3-5.4m0 8.9a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5M26.6 14.2a1.3 1.3 0 1 1-1.2-1.2 1.3 1.3 0 0 1 1.2 1.2" />
      </g>
    </svg>
  );
};

export const IN = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 39.6 39.6">
      <g>
        <path d="M19.8 39.6a19.8 19.8 0 1 1 19.8-19.8 19.8 19.8 0 0 1-19.8 19.8Zm0-38.1A18.3 18.3 0 1 0 38 19.8 18.3 18.3 0 0 0 19.8 1.5Z" />
        <path d="M11.2 15.5H15v12.7h-4zM13.1 13.9a2.3 2.3 0 1 0-2.3-2.4A2.3 2.3 0 0 0 13 14ZM21.4 21.6c0-1.8.8-2.9 2.4-2.9 1.4 0 2.1 1 2.1 2.9v6.7h4v-8.1c0-3.4-2-5-4.7-5a4.4 4.4 0 0 0-3.8 2v-1.7h-3.8v12.8h3.8Z" />
      </g>
    </svg>
  );
};

export const GooglePlay = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 243 71.5">
      <path d="M233.8 0H9.1A9.2 9.2 0 0 0 0 9.2v53.2a9.1 9.1 0 0 0 9.1 9.1h224.7a9.1 9.1 0 0 0 9.2-9.1V9.2a9.2 9.2 0 0 0-9.2-9.2Zm7.4 62.4a7.3 7.3 0 0 1-7.4 7.3H9.1a7.3 7.3 0 0 1-7.3-7.3V9.2a7.3 7.3 0 0 1 7.3-7.4h224.7a7.3 7.3 0 0 1 7.4 7.4Z" />
      <path d="M192.3 31.5v22.4h3.3V31.5Zm30.2 8-3.9 9.8h-.1l-4-9.7h-3.6l6 13.6-3.4 7.5h3.5l9.2-21.1Zm-18.6-.4a6.3 6.3 0 0 0-6 3.4l3 1.3a3.2 3.2 0 0 1 3-1.7c1.7 0 3.5 1 3.5 2.9v.2a7.3 7.3 0 0 0-3.5-.8c-3.2 0-6.4 1.7-6.4 5 0 3 2.6 5 5.5 5a4.7 4.7 0 0 0 4.3-2.2h.1v1.7h3.3v-8.6c0-4-3-6.2-6.8-6.2Zm-.5 12.3c-1 0-2.6-.6-2.6-2 0-1.6 2-2.3 3.6-2.3a6 6 0 0 1 3 .7 4 4 0 0 1-4 3.6Zm-20.3-20h-8V54h3.3v-8.5h4.7a7 7 0 1 0 0-14Zm0 11h-4.7v-7.8h4.7a3.9 3.9 0 1 1 0 7.7Zm-40-2.8v1.2h-.1a5.3 5.3 0 0 0-4-1.7 7.6 7.6 0 0 0 0 15.3 5.2 5.2 0 0 0 4-1.7h.1v1c0 3-1.5 4.5-4 4.5a4.3 4.3 0 0 1-4-2.7l-2.8 1.2a7.3 7.3 0 0 0 6.7 4.6c4 0 7.3-2.3 7.3-8V39.6Zm-3.8 11.8a4.6 4.6 0 0 1 0-9.3c2.3 0 4 2 4 4.7s-1.7 4.6-4 4.6Zm9.3-20V54h3.4V31.5Zm12.6 20a3.9 3.9 0 0 1-3.7-2.3l10.2-4.3-.4-.8c-.6-1.7-2.5-4.9-6.5-4.9s-7.2 3.1-7.2 7.7a7.5 7.5 0 0 0 7.6 7.6 7.6 7.6 0 0 0 6.3-3.4l-2.6-1.7a4.4 4.4 0 0 1-3.7 2Zm-.3-9.3a3 3 0 0 1 2.8 1.6l-6.8 2.8a4.2 4.2 0 0 1 4-4.4Zm-64-.6h-11v3.2h7.8a6.8 6.8 0 0 1-1.8 4 8 8 0 0 1-6 2.5 8.6 8.6 0 0 1 0-17.3 8.2 8.2 0 0 1 5.9 2.3l2.3-2.2a11.3 11.3 0 0 0-8.2-3.3 11.9 11.9 0 1 0 0 23.7 10.8 10.8 0 0 0 8.3-3.3 10.6 10.6 0 0 0 2.8-7.6 11.6 11.6 0 0 0-.1-2Zm9-2.4a7.6 7.6 0 1 0 7.6 7.7 7.5 7.5 0 0 0-7.7-7.7Zm0 12.3a4.6 4.6 0 1 1 4.3-4.6 4.4 4.4 0 0 1-4.4 4.6ZM122.6 39a7.6 7.6 0 1 0 7.7 7.7 7.5 7.5 0 0 0-7.7-7.7Zm0 12.3a4.6 4.6 0 1 1 4.3-4.6 4.4 4.4 0 0 1-4.3 4.6ZM57.2 34.2 49 29.5H49l-6.5 6.3-.1.2.1.1 6.5 6.4h.1l8.2-4.7c1-.5 1.5-1.2 1.5-1.8 0-.7-.5-1.3-1.5-1.8ZM41.3 37.2l-.1.2-20.8 20.8a1 1 0 0 0 .2 0 3.2 3.2 0 0 0 1.6-.5l25-14.2.2-.1-6-6ZM41.3 34.7l.2-.1 6-6-.2-.1-25-14.2a3.2 3.2 0 0 0-1.7-.5 1.2 1.2 0 0 0-.2 0l20.8 20.8ZM40.3 36l-.1-.2-21-21a.8.8 0 0 0 0 .3 3.4 3.4 0 0 0-.2 1v39.7a3.4 3.4 0 0 0 .1 1 .8.8 0 0 0 .1.3l21-21Z" />
      <g>
        <path d="M80.4 18v1.2h3A3 3 0 0 1 80 22a4 4 0 0 1 0-8.1 3.9 3.9 0 0 1 2.6 1l1-1a5.3 5.3 0 0 0-3.6-1.4 5.4 5.4 0 0 0 0 10.9c3 0 5-1.8 5-5.5ZM88.4 21.9v-3.2h4.2v-1.3h-4.2V14h4.8v-1.3h-6.3v10.5h6.5V22ZM94.6 12.7V14h3.2v9.2h1.4V14h3.2v-1.3ZM107.9 12.7v10.5h1.4V12.7ZM111.2 12.7V14h3.2v9.2h1.4V14h3.2v-1.3ZM129 12.5a5.4 5.4 0 1 0 5.4 5.5 5.3 5.3 0 0 0-5.3-5.5Zm0 9.5a4 4 0 1 1 4-4 4 4 0 0 1-4 4ZM142.8 12.7v7.9l-4.8-8h-1.4v10.6h1.5v-8l4.8 8h1.3V12.7Z" />
      </g>
    </svg>
  );
};

export const AppStore = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 243 71.5">
      <path d="M233.9 71.5H9A9.2 9.2 0 0 1 0 62.4V9A9.2 9.2 0 0 1 9.1 0H234a9.2 9.2 0 0 1 9.1 9.1v53.3a9.2 9.2 0 0 1-9.1 9.1ZM9 1.8a7.3 7.3 0 0 0-7.3 7.3v53.3a7.3 7.3 0 0 0 7.3 7.3H234a7.3 7.3 0 0 0 7.3-7.3V9a7.3 7.3 0 0 0-7.3-7.3Z" />
      <g>
        <path d="m80.9 20.3-1 3.4h-2.2l3.7-11.8h2.8L88 23.7h-2.3l-1-3.4Zm3.4-1.6-1-2.9-.6-2.2-.5 2.2-1 3ZM91.2 15.2l1.4 4.3.6 2.1.6-2.1 1.3-4.3h2.3L94 23.7h-2l-3.2-8.5ZM106 21.6a11.4 11.4 0 0 0 0 2h-1.9l-.1-.9a3.1 3.1 0 0 1-2.6 1.2 2.5 2.5 0 0 1-2.6-2.6c0-2 1.9-3.2 5-3.2V18c0-.6-.2-1.5-1.7-1.5a4.5 4.5 0 0 0-2.3.6l-.4-1.4a6.1 6.1 0 0 1 3-.7c2.8 0 3.5 1.7 3.5 3.6Zm-2.1-2c-1.6-.1-3 .2-3 1.5a1.1 1.1 0 0 0 1.2 1.2 1.8 1.8 0 0 0 1.7-1.1 1.5 1.5 0 0 0 0-.5ZM110 14Zm-1 9.7v-8.5h2.1v8.5ZM114.2 11.3h2.1v12.4h-2.1ZM126 21.6a11.4 11.4 0 0 0 .2 2h-2l-.1-.9a3.1 3.1 0 0 1-2.6 1.2 2.5 2.5 0 0 1-2.6-2.6c0-2 1.9-3.2 5-3.2V18c0-.6-.2-1.5-1.7-1.5a4.5 4.5 0 0 0-2.3.6l-.4-1.4a6.1 6.1 0 0 1 3-.7c2.7 0 3.5 1.7 3.5 3.6Zm-2-2c-1.6-.1-3 .2-3 1.5a1.1 1.1 0 0 0 1.2 1.2 1.8 1.8 0 0 0 1.7-1.1 1.5 1.5 0 0 0 0-.5ZM129 11.3h2.2v5A3 3 0 0 1 134 15c2 0 3.5 1.7 3.5 4.3 0 3-2 4.6-3.8 4.6a3 3 0 0 1-2.7-1.5l-.2 1.3H129v-2.4Zm2.2 8.9a2.4 2.4 0 0 0 0 .5 2 2 0 0 0 2 1.5c1.3 0 2.1-1 2.1-2.8 0-1.5-.7-2.7-2.1-2.7a2 2 0 0 0-2 1.5 2.5 2.5 0 0 0 0 .6ZM140 11.3h2.2v12.4H140ZM146.8 20c0 1.6 1.2 2.2 2.6 2.2a6.8 6.8 0 0 0 2.4-.4l.3 1.5a7.6 7.6 0 0 1-3 .5 4 4 0 0 1-4.4-4.2c0-2.4 1.5-4.6 4.2-4.6s3.6 2.3 3.6 4.1a5.4 5.4 0 0 1 0 1Zm3.7-1.5a1.8 1.8 0 0 0-1.7-2 2.1 2.1 0 0 0-2 2ZM163.1 23.9a4.1 4.1 0 0 1-4.2-4.4 4.2 4.2 0 0 1 4.4-4.5 4 4 0 0 1 4.2 4.3A4.2 4.2 0 0 1 163 24Zm0-1.6c1.3 0 2.2-1.2 2.2-2.9 0-1.3-.6-2.9-2.1-2.9s-2.1 1.5-2.1 3c0 1.6.8 2.8 2 2.8ZM170 17.7v-2.5h1.8l.1 1.3a3.1 3.1 0 0 1 2.8-1.5c1.4 0 3 1 3 3.6v5h-2.2V19c0-1.2-.4-2.2-1.6-2.2a1.8 1.8 0 0 0-1.7 1.3 2 2 0 0 0 0 .7v5H170ZM187.6 13v2.2h2v1.6h-2v3.7c0 1 .2 1.6 1 1.6a2.8 2.8 0 0 0 .9-.1v1.6a4.7 4.7 0 0 1-1.5.2 2.5 2.5 0 0 1-1.9-.7 3.3 3.3 0 0 1-.6-2.3v-4h-1.2v-1.6h1.2v-1.6ZM192 11.3h2.1v5a2.8 2.8 0 0 1 1.1-1 3 3 0 0 1 1.5-.3c1.5 0 3 1 3 3.7v5h-2.2v-4.8c0-1.2-.4-2.2-1.6-2.2a1.8 1.8 0 0 0-1.7 1.2 1.9 1.9 0 0 0 0 .7v5H192ZM204.2 20c0 1.6 1.3 2.2 2.7 2.2a6.8 6.8 0 0 0 2.3-.4l.3 1.5a7.6 7.6 0 0 1-3 .5 4 4 0 0 1-4.3-4.2c0-2.4 1.4-4.6 4.1-4.6 2.8 0 3.7 2.3 3.7 4.1a5.4 5.4 0 0 1 0 1Zm3.8-1.5a1.8 1.8 0 0 0-1.8-2 2.1 2.1 0 0 0-2 2Z" />
      </g>
      <g>
        <path d="M54.2 35a10.5 10.5 0 0 1 5-8.7 10.7 10.7 0 0 0-8.4-4.6c-3.6-.3-7 2.2-8.8 2.2-1.9 0-4.7-2.1-7.7-2a11.2 11.2 0 0 0-9.4 5.7c-4.1 7-1 17.5 2.9 23.2 2 2.8 4.2 6 7.2 5.8 3-.1 4-1.9 7.6-1.9 3.5 0 4.5 2 7.6 1.8 3.1 0 5.1-2.8 7-5.6a23.1 23.1 0 0 0 3.2-6.5 10.1 10.1 0 0 1-6.2-9.3M48.5 18a10.3 10.3 0 0 0 2.3-7.4A10.5 10.5 0 0 0 44 14a9.8 9.8 0 0 0-2.4 7.1 8.7 8.7 0 0 0 6.9-3.2M96.6 56.2h-4l-2.3-7h-7.8l-2.1 7h-4l7.7-24H89Zm-7-10-2-6.3-1.2-4.5h-.1L85.2 40l-2 6.3ZM116.4 47.3a9.8 9.8 0 0 1-2.4 7 7 7 0 0 1-5.2 2.2 5.3 5.3 0 0 1-5-2.4v9h-3.9V39h3.3l.2 2.7a6.8 6.8 0 0 1 11-.7 9.5 9.5 0 0 1 2 6.4m-3.9.1a7.1 7.1 0 0 0-1.1-4.1 4 4 0 0 0-3.4-1.7 4 4 0 0 0-2.5 1A4.4 4.4 0 0 0 104 45a5 5 0 0 0-.2 1.2V49a4.6 4.6 0 0 0 1.1 3.2 3.8 3.8 0 0 0 3 1.3 4 4 0 0 0 3.4-1.6 7.3 7.3 0 0 0 1.2-4.4M136.3 47.3a9.8 9.8 0 0 1-2.4 7 7 7 0 0 1-5.3 2.2 5.3 5.3 0 0 1-4.9-2.4v9h-4V39h3.3l.2 2.7h.1a6.8 6.8 0 0 1 11-.7 9.5 9.5 0 0 1 2 6.4m-4 .1a7.1 7.1 0 0 0-1-4.1 4 4 0 0 0-3.4-1.7 4 4 0 0 0-2.6 1 4.4 4.4 0 0 0-1.5 2.4 4.8 4.8 0 0 0-.2 1.2V49a4.6 4.6 0 0 0 1.2 3.2 3.8 3.8 0 0 0 3 1.3 4 4 0 0 0 3.4-1.6 7.4 7.4 0 0 0 1.2-4.4M158.5 49.4a6.4 6.4 0 0 1-2.2 5 9.4 9.4 0 0 1-6.5 2.1 11.4 11.4 0 0 1-6.2-1.5l1-3.2a10.5 10.5 0 0 0 5.5 1.5 5.3 5.3 0 0 0 3.3-1 3.2 3.2 0 0 0 1.2-2.6 3.3 3.3 0 0 0-1-2.4 9.3 9.3 0 0 0-3.3-1.9q-6.3-2.3-6.3-6.8a6 6 0 0 1 2.2-4.9 8.7 8.7 0 0 1 6-1.8 11.6 11.6 0 0 1 5.3 1l-1 3.2a9.5 9.5 0 0 0-4.5-1 4.6 4.6 0 0 0-3.2 1 2.9 2.9 0 0 0-1 2 3 3 0 0 0 1.2 2.4 12.5 12.5 0 0 0 3.5 1.9 11.8 11.8 0 0 1 4.5 2.9 6.1 6.1 0 0 1 1.5 4.1M171.2 41.8h-4.3V50q0 3.2 2.3 3.2a7 7 0 0 0 1.7-.1V56a8.6 8.6 0 0 1-3 .4 4.6 4.6 0 0 1-3.5-1.4q-1.2-1.4-1.2-4.6v-8.7h-2.6v-3h2.6v-3l3.7-1.2v4.3h4.2ZM190.2 47.4a9.5 9.5 0 0 1-2.2 6.5 8.1 8.1 0 0 1-6.4 2.6 7.7 7.7 0 0 1-6-2.5 9.2 9.2 0 0 1-2.3-6.3 9.4 9.4 0 0 1 2.3-6.6 8 8 0 0 1 6.3-2.6 7.9 7.9 0 0 1 6.1 2.6 9.1 9.1 0 0 1 2.2 6.3m-4 .1a7.8 7.8 0 0 0-1-4.1 3.8 3.8 0 0 0-3.4-2 3.8 3.8 0 0 0-3.5 2 8 8 0 0 0-1 4.2 7.8 7.8 0 0 0 1 4 3.9 3.9 0 0 0 3.4 2.1 3.8 3.8 0 0 0 3.5-2 7.8 7.8 0 0 0 1-4.2M202.7 42.3a6.9 6.9 0 0 0-1.2-.1 3.6 3.6 0 0 0-3.1 1.5 5.8 5.8 0 0 0-1 3.4v9h-3.8V44.3l-.1-5.4h3.3l.1 3.3h.1a6 6 0 0 1 2-2.7 4.6 4.6 0 0 1 2.7-1 6.2 6.2 0 0 1 1 .1ZM219.8 46.7a9.3 9.3 0 0 1-.1 1.7h-11.5a5 5 0 0 0 1.7 4 5.7 5.7 0 0 0 3.7 1.2 12.7 12.7 0 0 0 4.7-.9l.6 2.7a14.4 14.4 0 0 1-5.8 1 8.4 8.4 0 0 1-6.3-2.3 8.7 8.7 0 0 1-2.3-6.3 9.9 9.9 0 0 1 2.1-6.5 7.3 7.3 0 0 1 6-2.8 6.4 6.4 0 0 1 5.7 2.8 9.3 9.3 0 0 1 1.5 5.4m-3.6-1a5.2 5.2 0 0 0-.8-3 3.4 3.4 0 0 0-3-1.5 3.6 3.6 0 0 0-3 1.5 5.7 5.7 0 0 0-1.2 3Z" />
      </g>
    </svg>
  );
};

export const Arrow = ({ width, height, color, direction }: IconsPropsType) => {
  return (
    <svg
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 9.4 14.4"
      style={{
        transform:
          direction === "right"
            ? "rotate(90deg)"
            : direction === "down"
            ? "rotate(180deg)"
            : direction === "left"
            ? "rotate(-90deg)"
            : "none",
      }}
    >
      <path d="M.3 5.4a1 1 0 0 0 1.3 0l2.1-2.2v10.3a1 1 0 1 0 2 0V3.2l2 2.2a1 1 0 0 0 1.4 0 1 1 0 0 0 0-1.4L5.4.3A1 1 0 0 0 4 .3L.3 4a1 1 0 0 0 0 1.4Z" />
    </svg>
  );
};

export const Egypt = ({ width, height }: IconsPropsType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 512 512">
      <path d="M0 341.3h512V512H0z" />
      <path fill="#fff" d="M0 170.7h512v170.6H0z" />
      <path fill="#ce1126" d="M0 0h512v170.7H0z" />
      <g fill="#fff" stroke="#c09300" transform="translate(-128) scale(.85333)">
        <path
          strokeLinejoin="round"
          strokeWidth="1.3"
          d="m450.8 302.4 68.5 63.6-4.9-115.5c-.7-17.5-15.9-13.5-27-7.2-11.1 7.2-24 7.2-37.4 2.5-13.5 4.7-26.3 4.7-37.4-2.5-11-6.3-26.3-10.3-27 7.2L380.7 366l70.1-63.6z"
        />
        <path
          id="a"
          fill="#c09300"
          stroke="none"
          d="m393.5 246.5-4.8 112.3-8 7.2 4.9-115.5a24 24 0 0 1 7.9-4zm9.6 8-4 94-8 8.2 4.8-108.5c1.6 1.6 6.3 5.5 7.2 6.3zm8.7 7.2-3.1 78.4-6.5 6.3 4-89.4c1.6 1.5 4.8 3.8 5.6 4.7zm9.5 4-3.1 66.8-6.3 5.1 3.1-74.3c1.6.7 4.7 2.4 6.3 2.4zm8.8 0-2.3 55.7-6.5 6.3 2.5-61.3c1.5 0 5.6 0 6.3-.7z"
        />
        <use width="100%" height="100%" transform="matrix(-1 0 0 1 900 0)" />
        <path
          fill="#c09300"
          strokeWidth="1.1"
          d="m453.2 315 9.6 43.8-3.2 3.2-3.3-2.5-5.4-39 2.3 39-3.2 4-3.1-4 2.3-39-5.5 39-3.3 2.5-3.2-3.2 9.6-43.7h6.4z"
        />
        <g id="b" fill="none" strokeLinejoin="round" strokeWidth="1.3">
          <path fill="#fff" strokeWidth="1.2" d="m428.5 295.8-19.1 67.7 26.3 4 11.1-50.9-18.3-20.8z" />
          <path d="m422.2 319 2.3 5.5 12.4-11.8" />
          <path d="m430.8 305 2.6 24.3 7.9-10.4m-3.2 4 4.3 15m1.7-5.5-8.7 13.2m2.7 13.2-2.8-13.2-2.4-13.4-5.9 7.9-2.5-9.1-8.2 8.4 4.1 15.2 5.8-9.4 3.1 9.6 6-9.2" />
          <path d="m415 362 5.3-7.5 3.4 11.5 4.8-8 3.1 9.6" />
        </g>
        <use width="100%" height="100%" transform="matrix(-1 0 0 1 900 0)" />
        <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.3">
          <path
            strokeWidth="2.4"
            d="M450 393.8c20 0 39-1.6 50.2-4.7 4.7-.9 4.7-3.3 4.7-6.5 4.8-1.6 2.4-7.2 5.7-7.2-3.4 1-4-5.5-8-4.7 0-5.6-5.7-6.3-10.4-4.7-9.5 3.1-26.3 3.9-42.2 3.9-16-.8-32.6-.8-42.2-4-4.7-1.5-10.3-.8-10.3 4.8-4-.8-4.7 5.6-8 4.7 3.3 0 .8 5.7 5.6 7.2 0 3.2 0 5.6 4.8 6.5 11 3.1 30.2 4.7 50.1 4.7z"
          />
          <path d="M422.9 363.5c6.4.9 13.6 1.6 19.2.9 3.2 0 5.5 5.5-.9 6.3-5.5.7-14.3 0-19-.8a231 231 0 0 1-18.4-4c-5.6-2.4-1.6-7 1.6-6.4a105.3 105.3 0 0 0 17.5 4zm54.2 0c-6.4.9-13.6 1.6-19 .9-3.4 0-5.7 5.5.7 6.3 5.6.7 14.3 0 19-.8 4-.8 12.8-2.3 18.4-4 5.6-2.4 1.6-7-1.6-6.4a105.2 105.2 0 0 1-17.5 4z" />
          <path d="M403 360.4c-4.8-.9-7 4.7-5.5 7.9.7-1.6 4-1.6 4.7-3.2.9-2.4-.7-2.4.9-4.7zm19.2 14.7c0-3.2 3.1-2.8 3.1-6 0-1.5-.8-4-2.4-4a3.4 3.4 0 0 0-3.2 3.2c-.7 3.1 2.5 3.6 2.5 6.8zm22.7-9.1c4.7 0 4.2 6.3 2 9.5 0-2.3-4-3.2-4-4.8 0-2.4 3.6-2.4 2-4.7zm52-5.6c4.9-.9 7.2 4.7 5.6 7.9-.7-1.6-4-1.6-4.7-3.2-.9-2.4.7-2.4-.9-4.7zM478 375c0-3.2-3.2-2.8-3.2-6 0-1.5.8-4 2.4-4a3.4 3.4 0 0 1 3.2 3.2c.7 3.1-2.5 3.6-2.5 6.8zm-23-9c-4.7 0-4.2 6.3-2 9.5 0-2.3 4-3.2 4-4.8 0-2.4-3.6-2.4-2-4.7z" />
          <path
            strokeWidth=".9"
            d="M404.7 362c1.6 0 4 .7 4.7 1.6l-4.7-1.6zm7.9 2.4c.8 0 4 .7 5.5 1.6l-5.5-1.6zm28.6 3.2c-1.5 0-4.7 0-5.5.7l5.5-.8zm-8.7 0c-.9-.9-4-.9-5.6 0h5.6zm62.8-5.6a8 8 0 0 0-4.7 1.6l4.7-1.6zm-7.8 2.4c-1 0-4 .7-5.6 1.6l5.6-1.6zm-28.7 3.2c1.5 0 4.7 0 5.6.7l-5.6-.8zm8.7 0c.9-.9 4-.9 5.6 0h-5.6z"
          />
          <g fill="#c09300" stroke="none">
            <path d="M403.3 374.6c-.5-.1-.8-.6-.6-1 .1-.7.6-1 1-.8.4 0 .9.6.9.8l-.4.7-.2.1c0 .2-.4.2-.7.2zm55 3.9c-.2 0-.6-.5-.6-.7 0-.4.6-1 1-1l.8.4c.3.3.3.9-.1 1.2-.2.2-.8.2-1.1 0zm.3 2.5c-.4-.2-.5-.4-.6-.8 0-.5 0-.6.5-.9l.4-.2.4.2c.4.2.7.4.7.8 0 .3-.3.6-.7.8-.3.2-.4.2-.7 0z" />
            <path d="M407.8 370c-.4 0-.9.4-1.2.6-.6.1-1.4.5-2 0-.6-.1-1.4 0-1.5.8.1.7 1 1 1.6.6.4-.5 1.5-.9 1.7 0-.5.8-.4 1.7-.8 2.4 0 .5-.3.9-.5 1.3-.5 0-1 0-1.4.3a2 2 0 0 0-1.6.8c-.4.6-.8 1.2-.9 2 .1.6 1 .8 1.6.9l2 .6 3.2.9c1.6.5 3.2.7 4.8 1.1l.5.1c.7.2 1-.5 1-1l1-3.6c.2-.5.5-1.5-.4-1.3-.5.3-1 .8-1.6.8-.9 0-.4 1 0 1.3 0 .6-.2 1.3-.5 1.8-.6.3-1.2 0-1.8-.2-.5 0-1.7-.3-1.2-1l.5-1.8c.3-.6.3-1.3.5-2-.4-.7-1 .3-1.5.4-.4.2-1.6.3-1 1 .6.4.2 1.1 0 1.7 0 .7-.8 1-1.4.7-.6 0-1.5-.5-1-1.1l.5-1.8.7-2c0-.7.3-1.2.6-1.8 0-.7.5-1.3.5-2 0-.3-.2-.4-.4-.4zm-3.7 7.3a.3.3 0 0 1 .3 0c.2.2.2.4 0 .6l-.3.2c-.5 0-.6-.1-.6-.3 0-.1 0-.2.3-.3a1.4 1.4 0 0 1 .4-.2zm-1 5c-.5-.4-.4-.7.3-1.3.4-.2.5-.2.9.1.6.5.6.8 0 1.3-.2.2-.3.2-.5.2-.3 0-.4 0-.7-.2zm3 1a.9.9 0 0 1-.6-1.1c.2-.4.3-.5.9-.5.7 0 .8.1.9.7 0 .4 0 .5-.3.7a1 1 0 0 1-.8.2zm89.2 0c-.2-.1-.3-.2-.3-.5 0-.4.2-.7.8-.9.6-.3 1-.3 1.2.2.3.6.3.8-.1 1.2-.2.3-.3.3-.8.3s-.6 0-.8-.2zm-85 1.2c-.4 0-.6-.4-.6-.8 0-.3 0-.4.2-.6l.6-.2.6.1c.5.4.6.8.3 1.2-.3.4-.6.4-1.2.3zm21.8 1-.2-.3c0-.6 0-1.1.2-1.7.1-.5 0-1 .2-1.5l.4-2.8c0-.5 0-1 .2-1.4.1-.8 0-1.5.2-2.2 0-.3.3-1 .6-.6.4.6.9 1 1.4 1.5.4.3 0 .7-.3.8-.4.1-.5.6-.5 1l-.2 1.2c0 .7 0 1.3-.2 2l-.1 1.8-.2 1.2c0 .4 0 .9-.4 1.1-.3.2-.8.2-1-.1zm29.7-9.8-1.3 1.2c-.6.5.5.7.6 1.1.2.6.2 1.2.2 1.8.2.6.3 1.1.2 1.7 0 .7-.8.5-1.2.9-.5.2-.7.7-1 1a4.2 4.2 0 0 0-.4 1.6c0 .5-.3 1 0 1.4l.1.2h.5l1.5-.1c1.2-.2 2.5-.2 3.7-.3l2.2-.2c.6.1.9-.5.9-1-.4-.7-.1-1.4-.4-2-.2-.8-.1-1.5-.2-2.2 0-.6-.7-.8-1-.4-.4.4-1 .5-1.2.9-.3.6.6.6.8 1l.1 1.5c.1.6-.5.6-1 .7-.5.2-1.2.3-1.5-.3-.2-.5-.2-1-.2-1.5 0-1-.3-1.8-.3-2.7 0-1-.3-2.1-.3-3.2 0-.5-.1-1.2-.8-1.1zm-.6 8.2h.3v.8l-.3.1a3.3 3.3 0 0 1-.4.1 2.5 2.5 0 0 1-.2 0c-.2-.2-.2-.5.1-.8l.5-.2zm-30-9.2c-.3 0-.8.7-1.2.6-.9.1-.8 1-.1 1.3v.8c.1.8-.4 1.5-.3 2.3 0 .8-.3 1.7-.3 2.6-.3.9-.3 1.8-.4 2.7-.1.8-.7.5-1.2.3v-1c.1-.9-.5-1.1-1.2-1.2-.7 0-1-.5-.8-1.1.3-.4 1-.3 1.5-.3 1 .2.9-1.1.4-1.6-.4-.6-1.2-1-1.4-1.6 0-.8-.5-1.7-1.2-2.1-1.1-.1-2 .8-2.3 1.8-.5 0-1 .2-1.4.4-.7.2-1.7 1.4-.7 1.9.5.1 2.2.5 1.4 1.2-.4.8-1.2.8-1.9.6-.7 0-1.5-.4-1.5-1.2-.1-.8-.1-1.6-.4-2.3-.2-.8-1.1-.6-1.2.2-.7.5-.6 1.4-.1 2 .3.7 0 1.6-.3 2.2-.2 1-1.2 1-1.9 1.2-.3.2-1.6 0-1.1.7a4 4 0 0 0 2.4.3c.8 0 1.5-.7 2-1.4.5-.5 1.4-.2 2.2-.2.7 0 1.5.5 2.3.1.2-.5 1.2-1.5 1.5-.5 0 .9.7 1.3 1.5 1.2.9 0 .5.6.5 1.2 0 .9.7 1.4 1.5 1.8h.8c.7-.3 1.5-.6 1.8-1.4.3-.7.3-1.5.5-2.2.2-1.1.4-2.3.4-3.4.3-1 .2-2.1.4-3.2l.3-2.3c0-.5-.2-.5-.5-.4zm-6.7 4.1c.1 0 .2.2.2.5 0 .4.2.7.5.8v.3l-.8.2c-.5 0-.9-.2-1.2-.5l-.2-.2.3-.2.5-.5c.3-.3.5-.4.7-.4zm66-7.9a8.4 8.4 0 0 0-1.7.3c-1 0-1.5 1-.5 1.6.6 1.5 1.5-.4 2.5-.2 1.4.2 1.5 1.8 1.8 3 0 1.1.4 2.2.7 3.3 1 1.1-.7 1.8-1.4 1-.6-.7-2-1.5-2.7-.6-.9.4-1 1.6-1.7 2-1.2.3-1.3-1.2-2-1.8-.6-.9-1.7-1-2.6-1.2-.4-.9-.2-2.4-1-3-.8.3-2.2 1.7-1 2.4 1 1-.5 1.4-1 2-.8.9-1 2-1 3-1.3.7-1.5-.8-1.7-1.7 0-1.1-1-.8-1.7-.4-1 .4-1.4 1.3-2 2v2c.2.9 1.2.5 1.8.4 1-.4 1.4.7.6 1.3-.6.6-2.2.3-2 1.4h1.6c1-.3 2.2-1.1 2.3-2.3.2-1 1.7-.9 2.5-1.1 1-.3 2.3-.4 2.6 1 .7.7 2.2 1.5 3 .5a2.4 2.4 0 0 0 1.1-2.3c-.1-.8 1.3-.8 1.7-.3.5.8 2.1.6 2.9 0 .8-.5 1-1.6 2.2-1.6l5.4-1.5c1.4-.3-.2-1.2-.6-1.8-1-.5-2 1.7-3.2.6-1-.7-.9-2-1.2-3.1-.3-1.4-.2-3-1.2-4-.6-.7-1.6-.9-2.5-.9zm-6.8 9.5c.1 0 .3 0 .5.2.4.2.7.6.7 1 0 .2 0 .2-.3.3l-.5.2c-.2 0-.7-.3-.7-.5v-.4c-.2-.4-.2-.4 0-.6l.3-.2zm6.5.4c.4 0 .6 0 .8.3.1.4 0 .6-.4.8l-.5.2-.4-.3c-.2-.1-.3-.2-.3-.4 0-.3.4-.6.8-.7zm-9 0c.2 0 .3 0 .4.2.2.2.3.3.3.6v.6c0 .3 0 .2-.6.2s-.7 0-.7-.6c0-.4 0-.5.3-.7.1-.2.3-.2.4-.2zm-5.4 1.5a.6.6 0 0 1 .4.4c0 .3 0 .5-.2.6-.3.1-.8.2-1 0a.6.6 0 0 1 0-.1c-.2-.1-.2-.2 0-.3v-.1l.2-.3a.5.5 0 0 1 .6-.2zm9.2 1.2.5.1v.6h-1.2l-.1-.2c0-.2 0-.3.2-.4l.6-.1zm-17.1 4.8c-.1 0-.3-.1-.1-.2.1-.3.5-.4.8-.6a3.4 3.4 0 0 0 1.4-1c0-.4.4-.6.4-1l-.1-1.4a1.8 1.8 0 0 0-.8-1c-.3-.1-.7-.2-.8-.6 0-.3.3-.6.4-.9l.6-1.2c.3-.3.7 0 .8.2l.5 1c.3.3.5.6.6 1 .2.4.4.7.4 1l.2 1.3c0 .5 0 1.1-.2 1.6l-.6.8c-.3.3-.6.6-1 .7-.3.1-.5.4-.9.4H468l-.1-.1zm-6.9.4c-.2-.2-.3-.3-.3-.6s0-.3.3-.6c.4-.4.6-.4 1.4 0 .7.4 1 .4 1 .1.1-.2.5-.5 1-.5a.8.8 0 0 1 .5.2c.2.2.3.3.3.7 0 .5 0 .5-.3.8-.3.2-.3.2-.7.2a.9.9 0 0 1-.8-.6c0-.2 0-.3-.2-.1l-.2.1c-.2 0-.6.3-.8.5l-.5.1c-.4 0-.4 0-.7-.3zm-19.8-8.9c-.7 0-1.4.6-1.5 1.3.2.7.8 1.5.4 2.2.3 1-.8 1.4-1.5.9-.4-1-.6-2-1.3-3-.8-.2-1.1 1.1-1.7 1.6.3.7 1.1 1.4 1.2 2.3.2 1-.4 2-1.1 2.4-.7.7-1.7.5-2.5.6-1 .6.7.8 1.2.8 1 .1 2.1 0 3-.8.7-.3.6-1.7 1.5-1.8l4.8.3c.8.2 2.1-.1 2.7.5 0 1 1 1.8 1.9 2.2.5.2 1-.5 1.5-.6 1-.3.7-1.5 1.3-2h5c.2 0 .3-.5.6-.7l-.2-1.9c-.3-.8 0-1.8-.5-2.5-.9-.2-1.6.5-2.4.6-1 .4-1.7 1.3-1.8 2.3-.5.9-1.4-.2-1-1l-.1-1c-.5-.5-1.4-.3-2.1-.4l-3-.2c-1 0-1.9.1-2.7-.1-1 0-1-1-1-1.8a1 1 0 0 0-.7-.2zm2 3.7 1 .1h1.3c1 .2 2 .2 3 .2.2 0 .4.2.6.4v2c0 .3 0 .7-.2.8a.7.7 0 0 1-.2.2 1 1 0 0 1-.7-.5v-1.4a1.3 1.3 0 0 0-.7-.3l-2.6-.1-2-.1c-.3-.1-.7 0-.9-.4-.2-.2.1-.6.4-.7a2.3 2.3 0 0 1 1-.2zm11.3.3c.1 0 .2 0 .2.3l.2.5c0 .1 0 .2-.2.2-.5.2-1 .2-1.2 0 0-.1 0-.5.2-.6l.8-.4z" />
          </g>
        </g>
        <path
          strokeWidth="1.1"
          d="M450 327.2c32.6-25 29.8-61.8 29.8-61.8l-2.5.2c-6.9 0-23.2-4-27-8.9-4 4.5-20.8 9-27.6 9l-2.5-.3s-2.9 36.7 29.8 61.8z"
        />
        <path
          strokeWidth=".9"
          d="M477.2 268h-.8c-6.2 0-20.6-3.1-26.2-7.9-5.8 4.4-20.5 8-26.6 8a4.7 4.7 0 0 1-.8-.1 73.1 73.1 0 0 0 2.6 18.7 71 71 0 0 0 24.6 37.1 71.2 71.2 0 0 0 24.6-37.2 73.1 73.1 0 0 0 2.6-18.6z"
        />
        <path
          fill="#c09300"
          stroke="none"
          d="M439.4 265a62.2 62.2 0 0 1-16.6 3l.1 4.1a72.8 72.8 0 0 0 2.5 14.5 71 71 0 0 0 14 26.8V265zm20.6 0v49.2a71.1 71.1 0 0 0 14.6-27.6 73 73 0 0 0 2.5-14.5l.1-4h-.8c-3.8 0-10.4-1.2-16.4-3.2z"
        />
        <g strokeWidth="1.3">
          <path
            strokeWidth="1.2"
            d="M462.3 253c.7.1-.9-3.5-.9-3.5 1.8 1.8 8.4 2.3 8.4 2.3-4-1.8-8-15.1-7.5-25.8.4-10.6-1.5-14.8-3-16.4-2-2-8.5-3.8-12.7-4-2.5-.1-2 1.8-2 1.8-4.5-1.1-9-1.6-11-.2-1.8 1.2-2.2 7.5-.8 6.4 3.3-2.7 6.2-.2 8.2 2.7 1.8 2.5 1.7 9.7-.9 18.2a60 60 0 0 1-10 17.7c4 0 9.6-3.5 9.6-3.5l-1.3 5.5c4.2-2 7.5-5.1 7.5-5.1l4 4.2c1.3-1.8 4-4.2 4-4.2s3.3 3.5 8.4 4z"
          />
          <path
            fill="none"
            d="M446.1 227.6s-2.2 16.4-6.4 21m10-21.5s-1 16.7-3.8 22m6.9-21.3s0 18.2 1 21.3m3-20.4s.8 15.3 4.6 20.8"
          />
          <path
            fill="#c09300"
            strokeWidth=".3"
            d="M442 219.6a8 8 0 0 0-1-3.3c-2-3-4.9-5.4-8.2-2.7 0 0 1.1-3.5 3.6-3.6 1.8-.1 6.1 1.4 9.9 7.8 0 0-2.8-.6-3.5 0-1.2 1-.7 1.8-.7 1.8z"
          />
          <path
            fill="#c09300"
            strokeWidth=".3"
            d="M432.4 209.3c.3-1 .7-1.8 1.3-2.1 2-1.4 6.4-1 10.9.2 0 0-.4-1.9 2-1.8 4.2.2 10.6 2 12.6 4a7.9 7.9 0 0 1 1.5 2.4c-1-1.4-3.8-1.3-4.5-1.2-1 .1-1.7 0-3.1.4-.7.2-1.7.4-2.3.8-.4.4-.8 1.6-1.4 1.6-1 0-1-.2-1.3-.5-.3-.5-.5-1.1-.9-1-1 .1-2.8-.7-5-2.5-2.3-1.8-3.2-2.2-6-2-3 .2-3.8 1.9-3.8 1.9v-.2z"
          />
          <circle cx="448.8" cy="210.7" r="1.2" stroke="none" />
        </g>
      </g>
    </svg>
  );
};

export const Phone = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill="none" viewBox="0 0 50 50">
      <path d="M0 0h50v50H0z" />
      <path
        d="m30.2 35.3 5.1-3c1-.5 2.2-.6 2.8-.2l10.2 6.7c.7.5 1 2 0 3.3-.9 1.4-5.4 7-7.3 6.9-1.9 0-9.8-.2-24.8-15.2S1.1 10.8 1 9c0-2 5.5-6.4 6.9-7.4 1.4-1 2.8-.6 3.3 0l6.7 10.2c.4.7.3 1.8-.3 2.9l-2.9 5s1.7 2.9 7.2 8.4 8.3 7.2 8.3 7.2z"
        strokeMiterlimit="10"
        strokeWidth="3"
        stroke={color}
      />
    </svg>
  );
};

export const Whatsapp = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 56.7 56.7">
      <path d="M29.8 16.2A12.3 12.3 0 0 0 19.3 35l.3.5-1.2 4.5 4.6-1.2.5.2c1.9 1.2 4 1.8 6.2 1.8a12.3 12.3 0 0 0 0-24.6zM37 33.7c-.3.9-1.8 1.7-2.5 1.8a5 5 0 0 1-2.3-.2c-.6-.1-1.3-.3-2.1-.7-3.8-1.6-6.2-5.4-6.4-5.6-.1-.3-1.5-2-1.5-3.8 0-1.8 1-2.7 1.3-3.1.4-.4.8-.5 1-.5h.7c.2 0 .6 0 .9.7l1 2.7c.2.2.2.4.1.7l-.3.6-.6.6c-.2.2-.4.4-.2.8.3.4 1 1.6 2 2.5 1.5 1.3 2.7 1.7 3 1.9.4.2.6.1.9-.1.2-.3.9-1 1.1-1.5.3-.3.5-.3.9-.1.3 0 2.1 1 2.5 1.2.4.1.6.2.7.4 0 .1 0 .9-.2 1.7z" />
      <path d="M29.2 4.4a24.6 24.6 0 1 0 0 49.2 24.6 24.6 0 0 0 0-49.2zm.5 38.8c-2.4 0-4.9-.6-7-1.7l-7.9 2 2.1-7.7a14.8 14.8 0 1 1 12.8 7.4z" />
    </svg>
  );
};

export const Location = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} id="map">
      <path d="M5.216 6.215 2 3v12h12l-4.03-4.029m1.147-1.853L15 13V2H4L6.33 4.33l.71.71c2.875-.29 2.875-.29 3.094 3.094z"></path>
      <path
        fill="#f05542"
        d="M8.355 3.998c-1.854 0-3.356 1.516-3.356 3.385 0 1.869 3.356 5.615 3.356 5.615s3.355-3.746 3.355-5.615c0-1.869-1.502-3.385-3.355-3.385zm0 1.881a1.118 1.128 0 0 1 1.117 1.127 1.118 1.128 0 0 1-1.117 1.129 1.118 1.128 0 0 1-1.12-1.129 1.118 1.128 0 0 1 1.12-1.127z"
      ></path>
    </svg>
  );
};

export const LightTruck = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 292.000000 110.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M1106 1078 c-22 -19 -30 -41 -46 -128 -11 -58 -22 -115 -25 -127 l-5
-23 -459 0 -458 0 -25 -25 c-27 -26 -38 -77 -38 -168 0 -38 -6 -58 -25 -83
-25 -32 -26 -38 -23 -155 l3 -122 55 -19 c76 -26 183 -48 235 -48 36 0 44 -3
49 -23 11 -47 64 -104 120 -132 48 -23 66 -27 120 -23 88 5 149 43 195 121
l34 57 698 0 698 0 17 -32 c68 -136 205 -185 333 -122 53 27 106 85 117 130 5
19 14 22 88 26 92 6 140 26 150 60 3 13 6 51 6 84 0 46 -5 68 -20 86 -14 19
-22 54 -31 139 -12 107 -15 116 -44 145 -56 58 -191 85 -480 100 l-130 6 -113
86 c-278 213 -255 206 -653 210 l-317 3 -26 -23z m675 -58 c68 -21 121 -54
294 -186 114 -87 131 -94 245 -94 181 0 410 -36 454 -71 29 -23 34 -49 11 -49
-12 0 -15 -15 -15 -71 l0 -72 -32 41 c-43 53 -74 77 -145 110 -49 22 -72 27
-143 27 -74 0 -93 -4 -150 -31 -135 -64 -220 -199 -220 -349 l0 -35 -569 0
-568 0 -6 67 c-8 87 -32 151 -77 210 -125 167 -375 191 -536 50 -59 -52 -102
-139 -116 -236 -10 -65 -15 -80 -28 -77 -8 3 -41 12 -73 20 l-57 17 0 88 c0
75 3 90 20 106 11 10 24 32 28 49 6 24 17 34 48 44 56 19 94 58 94 99 l0 33
-60 0 c-33 0 -60 4 -60 8 0 30 28 32 490 32 l466 0 23 123 c13 67 28 132 32
145 l9 22 289 0 c260 0 295 -2 352 -20z m-1069 -427 c111 -49 178 -150 186
-275 l5 -78 -27 0 c-25 0 -26 2 -26 63 -1 152 -122 271 -276 270 -151 -1 -264
-110 -281 -273 -5 -55 -8 -61 -27 -58 -19 3 -21 9 -20 58 2 81 29 152 80 209
55 61 94 86 165 106 70 19 146 12 221 -22z m1885 -4 c113 -55 183 -165 183
-289 0 -56 -1 -60 -24 -60 -22 0 -24 5 -28 68 -11 155 -125 265 -273 265 -149
1 -267 -112 -282 -269 -6 -60 -7 -64 -31 -64 -25 0 -25 0 -19 71 20 243 259
383 474 278z m-1947 -201 c50 -26 90 -89 90 -143 -1 -46 -34 -109 -71 -136
-27 -19 -47 -24 -95 -24 -51 0 -66 4 -98 29 -123 93 -58 295 94 296 20 0 56
-10 80 -22z m1880 -1 c50 -26 90 -90 90 -141 -1 -47 -33 -110 -71 -137 -51
-36 -142 -34 -192 4 -46 35 -67 74 -67 127 0 132 125 208 240 147z m328 1 c18
-18 15 -103 -4 -122 -25 -26 -31 -19 -38 42 -4 31 -9 65 -12 75 -4 13 1 17 18
17 13 0 29 -5 36 -12z"
        />
        <path
          d="M1225 998 c-2 -7 -9 -51 -15 -98 -6 -47 -13 -100 -17 -117 l-5 -33
76 0 76 0 0 130 0 130 -55 0 c-36 0 -57 -4 -60 -12z"
        />
        <path
          d="M1450 880 l0 -130 229 0 229 0 6 44 c4 25 16 56 26 69 l20 25 -64 41
c-104 68 -154 81 -311 81 l-135 0 0 -130z"
        />
        <path
          d="M1949 812 c-6 -21 -9 -49 -7 -62 3 -23 8 -25 53 -25 50 0 50 0 49 32
-2 39 -39 93 -64 93 -14 0 -23 -11 -31 -38z"
        />
        <path
          d="M1500 680 c0 -18 7 -20 65 -20 58 0 65 2 65 20 0 18 -7 20 -65 20
-58 0 -65 -2 -65 -20z"
        />
        <path
          d="M995 362 c-3 -3 -5 -14 -5 -24 0 -17 20 -18 458 -17 l457 2 -370 17
c-203 10 -407 20 -453 22 -45 3 -84 2 -87 0z"
        />
        <path
          d="M530 290 c-53 -53 13 -126 81 -90 28 15 26 74 -3 94 -30 21 -54 20
-78 -4z"
        />
        <path
          d="M2410 290 c-25 -25 -26 -62 -2 -83 39 -35 102 -9 102 41 0 28 -34 62
-60 62 -11 0 -29 -9 -40 -20z"
        />
      </g>
    </svg>
  );
};

export const RefrigeratorSemiTrailer = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 190.000000 83.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,83.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M20 810 c-19 -19 -20 -33 -20 -278 0 -187 3 -261 12 -270 17 -17 164
-16 170 0 11 29 -4 38 -63 38 l-59 0 0 235 0 235 845 0 845 0 0 -235 0 -235
-362 -2 c-355 -3 -363 -3 -363 -23 0 -20 8 -20 379 -23 271 -1 383 1 392 9 9
7 14 33 14 69 0 53 3 61 35 93 l35 35 0 134 c0 151 -3 158 -76 207 l-45 31
-860 0 c-846 0 -859 0 -879 -20z"
        />
        <path
          d="M280 703 c0 -25 -1 -25 -18 -10 -40 36 -45 6 -6 -34 29 -31 27 -59
-5 -59 -15 0 -23 11 -32 40 -14 45 -44 58 -33 14 6 -24 5 -25 -14 -15 -11 6
-23 11 -26 11 -13 0 -5 -23 11 -35 15 -11 15 -13 -5 -19 -40 -13 -23 -27 31
-24 46 3 52 1 52 -17 0 -18 -6 -20 -52 -17 -56 3 -71 -12 -30 -27 19 -8 20
-10 5 -16 -21 -8 -24 -35 -5 -35 7 0 19 6 26 13 11 10 12 7 7 -15 -11 -47 21
-35 34 12 8 30 16 40 31 40 32 0 34 -28 5 -59 -39 -40 -34 -70 6 -34 17 15 18
15 18 -10 0 -32 19 -36 27 -7 4 16 8 18 20 9 27 -23 35 6 8 31 -33 31 -34 73
-2 68 16 -2 24 -13 31 -40 10 -40 36 -52 36 -17 0 15 4 19 19 14 28 -9 35 12
9 26 l-22 12 22 8 c43 16 25 31 -28 24 -42 -6 -51 -4 -56 10 -10 25 15 36 64
29 29 -4 42 -3 42 6 0 6 -9 14 -20 17 -21 6 -21 6 0 20 27 19 12 40 -17 24
-18 -9 -20 -7 -15 14 8 42 -23 30 -34 -12 -7 -28 -15 -39 -31 -41 -32 -5 -31
37 2 68 27 25 19 54 -8 31 -12 -9 -16 -7 -20 9 -8 29 -27 25 -27 -7z m38 -146
c4 -20 -25 -34 -40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z"
        />
        <path
          d="M206 255 c-21 -14 -51 -25 -71 -25 -41 0 -65 -22 -65 -60 0 -46 10
-59 48 -66 25 -4 47 -18 65 -40 55 -65 152 -65 204 1 33 42 87 50 98 15 8 -25
51 -56 91 -64 43 -10 110 19 131 55 25 42 65 39 104 -6 59 -66 153 -66 206 0
22 27 35 35 61 35 31 0 32 -1 32 -46 0 -38 3 -45 18 -42 12 2 18 15 20 46 l3
42 281 0 281 0 36 39 c32 35 43 40 86 43 42 3 50 6 50 23 0 20 -8 20 -428 23
l-428 2 -37 25 c-49 33 -107 33 -156 0 -51 -34 -112 -34 -163 1 -31 21 -46 25
-86 21 -30 -2 -56 -12 -70 -26 -33 -31 -104 -29 -153 4 -25 17 -50 25 -79 25
-29 0 -54 -8 -79 -25z m118 -25 c58 -22 69 -110 19 -150 -76 -60 -183 23 -139
109 26 48 65 62 120 41z m337 -19 c37 -37 38 -79 3 -120 -21 -25 -33 -31 -65
-31 -86 0 -123 100 -58 154 41 35 83 34 120 -3z m298 14 c40 -20 55 -66 37
-110 -27 -63 -98 -75 -148 -25 -26 27 -30 36 -25 68 11 69 74 100 136 67z
m-809 -60 c0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0 8 7 15 15 15 8 0 15 -7
15 -15z m315 0 c0 -5 -10 -11 -22 -13 -16 -2 -23 2 -23 13 0 11 7 15 23 13 12
-2 22 -7 22 -13z m313 3 c-3 -7 -13 -13 -23 -13 -10 0 -20 6 -22 13 -3 7 5 12
22 12 17 0 25 -5 23 -12z m932 -3 c-19 -23 -660 -23 -660 0 0 13 44 15 336 15
298 0 335 -2 324 -15z"
        />
        <path
          d="M270 212 c-78 -25 -60 -128 21 -120 47 4 71 46 49 84 -16 29 -46 44
-70 36z m38 -59 c5 -17 -26 -29 -40 -15 -6 6 -7 15 -3 22 9 14 37 9 43 -7z"
        />
        <path
          d="M572 209 c-31 -12 -46 -54 -30 -87 16 -33 76 -43 102 -17 17 17 21
61 8 82 -12 19 -55 31 -80 22z m46 -56 c-5 -26 -38 -29 -38 -4 0 15 6 21 21
21 14 0 19 -5 17 -17z"
        />
        <path
          d="M900 212 c-78 -25 -60 -128 21 -120 47 4 71 46 49 84 -16 29 -46 44
-70 36z m33 -48 c9 -10 -4 -34 -18 -34 -17 0 -28 17 -20 30 7 11 28 13 38 4z"
        />
      </g>
    </svg>
  );
};

export const TractorHead = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 203.000000 110.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M1341 1023 c-33 -223 -43 -611 -16 -633 8 -7 15 -21 15 -31 0 -18
-11 -19 -205 -19 -176 0 -205 2 -205 15 0 10 10 15 30 15 17 0 30 5 30 10 0
16 -305 13 -322 -4 -8 -8 -26 -11 -46 -8 -51 7 -118 -7 -157 -34 -38 -25 -79
-31 -91 -13 -13 22 -90 49 -139 49 -49 0 -126 -27 -139 -49 -4 -6 -25 -11 -47
-11 l-39 0 0 -55 c0 -30 5 -55 10 -55 6 0 10 -11 10 -25 0 -18 5 -25 18 -25
13 0 22 -12 31 -39 12 -43 67 -97 107 -107 14 -4 48 -4 75 -2 40 4 57 12 84
38 19 19 37 42 41 52 8 27 37 21 59 -14 30 -47 68 -70 123 -76 67 -6 117 19
151 75 l26 42 340 1 340 0 22 -39 c30 -52 97 -85 159 -78 55 6 117 46 134 86
l12 31 82 0 c44 0 104 6 131 13 l50 13 -1 225 0 224 -56 190 c-75 250 -81 256
-288 270 -91 6 -267 30 -301 41 -14 4 -18 -9 -28 -73z m110 27 c30 -5 120 -16
201 -24 88 -9 158 -21 177 -30 34 -18 58 -57 63 -102 l3 -29 -232 -3 c-144 -1
-233 -6 -233 -12 0 -6 86 -10 229 -10 l229 0 11 -52 c39 -188 42 -195 67 -207
18 -8 24 -18 24 -41 0 -16 -4 -30 -10 -30 -5 0 -10 -22 -10 -50 0 -27 5 -50
10 -50 6 0 10 -9 10 -20 0 -12 -7 -20 -16 -20 -12 0 -14 -5 -9 -17 19 -45 18
-63 -4 -63 -14 0 -21 -6 -21 -20 0 -17 -7 -20 -50 -20 l-49 0 -26 55 c-48 101
-133 149 -251 143 -63 -3 -79 -8 -120 -37 -46 -32 -49 -33 -73 -18 l-26 16 1
208 c0 230 19 443 38 443 7 0 37 -4 67 -10z m236 -638 c44 -23 99 -80 114
-119 12 -33 12 -143 -1 -143 -5 0 -10 20 -10 45 0 118 -107 208 -229 191 -97
-13 -151 -77 -151 -178 0 -45 -3 -58 -15 -58 -12 0 -15 15 -15 77 0 63 4 84
25 118 25 43 59 71 104 86 41 13 134 3 178 -19z m-947 -63 c0 -12 -47 -12 -55
0 -3 5 5 11 17 13 27 5 38 1 38 -13z m626 -55 c-3 -9 -6 -45 -6 -80 l0 -64
-284 0 -283 0 -5 44 c-3 24 -13 58 -22 76 -9 18 -16 35 -16 37 0 1 140 3 311
3 280 0 311 -2 305 -16z m279 -69 c75 -74 -35 -185 -112 -113 -50 47 -12 138
57 138 19 0 40 -9 55 -25z m295 -6 c0 -18 -5 -20 -52 -17 -41 2 -54 7 -56 21
-3 14 5 17 52 17 50 0 56 -2 56 -21z m50 -38 c0 -11 -78 -31 -119 -31 -24 0
-31 4 -31 20 0 18 7 20 75 20 41 0 75 -4 75 -9z"
        />
        <path
          d="M1630 741 c0 -52 4 -82 13 -89 7 -6 63 -19 125 -30 88 -15 112 -16
112 -6 0 7 -12 14 -27 16 l-28 3 -3 93 -3 92 -94 0 -95 0 0 -79z"
        />
        <path
          d="M1830 735 c0 -78 2 -85 20 -85 18 0 20 7 20 85 0 78 -2 85 -20 85
-18 0 -20 -7 -20 -85z"
        />
        <path d="M1648 503 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
        <path
          d="M1150 260 c0 -18 7 -20 55 -20 48 0 55 2 55 20 0 18 -7 20 -55 20
-48 0 -55 -2 -55 -20z"
        />
        <path
          d="M1130 199 c0 -18 5 -20 52 -17 41 2 54 7 56 21 3 14 -5 17 -52 17
-50 0 -56 -2 -56 -21z"
        />
        <path
          d="M1560 196 c-6 -8 -10 -25 -8 -38 5 -34 71 -34 76 0 6 44 -41 70 -68
38z"
        />
      </g>
    </svg>
  );
};

export const Loaders = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 233.000000 110.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M567 1093 c-15 -15 -6 -49 16 -58 25 -11 35 -56 36 -166 1 -72 -4
-79 -70 -79 -26 0 -26 1 -31 88 -3 49 -11 98 -17 110 -13 25 -67 56 -81 47
-16 -10 -12 -75 4 -75 14 0 26 -67 26 -146 l0 -41 -82 -18 c-136 -29 -207 -54
-222 -78 -8 -12 -17 -52 -21 -89 l-7 -66 -42 -6 c-63 -10 -68 -16 -73 -92 l-5
-69 74 -43 c41 -23 84 -42 97 -42 13 0 45 -8 73 -18 37 -13 50 -23 55 -42 17
-72 81 -153 145 -186 38 -19 63 -24 128 -24 47 0 95 6 114 14 42 17 113 80
131 117 14 27 15 27 124 27 60 0 118 3 129 6 15 5 22 0 32 -23 18 -43 101
-117 147 -131 22 -7 76 -11 120 -9 118 6 172 43 249 175 10 17 17 14 96 -38
123 -81 177 -106 260 -119 139 -22 348 4 356 44 4 21 -65 141 -135 235 -46 63
-53 77 -48 103 5 20 1 38 -9 54 -15 22 -23 25 -79 25 -57 -1 -210 -30 -224
-43 -3 -3 -8 -26 -10 -52 -3 -25 -8 -45 -12 -45 -3 0 -19 16 -34 35 l-28 35
10 132 c6 73 11 160 11 194 0 59 -1 62 -30 74 -37 15 -76 6 -83 -19 -3 -13
-19 -23 -48 -30 -24 -6 -93 -25 -154 -42 l-110 -31 -85 35 c-65 27 -86 40 -88
57 -2 12 -14 26 -27 32 -18 8 -30 32 -55 112 -36 115 -53 146 -79 146 -10 0
-24 7 -31 15 -10 12 -47 15 -210 15 -108 0 -200 -3 -203 -7z m398 -44 c5 -5
18 -9 30 -9 19 -1 19 -1 2 -11 -15 -9 -17 -19 -13 -52 l5 -42 -12 45 c-12 40
-16 45 -52 53 -22 4 -71 6 -110 5 l-70 -3 -9 -147 c-5 -81 -5 -167 -2 -192 7
-43 9 -46 37 -46 33 0 79 -20 98 -44 10 -12 32 -16 82 -16 62 0 69 -2 69 -20
0 -23 -15 -27 -23 -7 -4 10 -41 15 -144 20 -76 3 -146 9 -155 12 -13 5 -18 24
-22 83 -4 71 -11 141 -31 324 l-8 67 159 -6 c88 -3 163 -9 169 -14z m-28 -37
c11 -7 42 -117 43 -149 0 -10 -30 -13 -115 -13 l-115 0 0 33 c0 17 3 56 6 85
l7 52 81 0 c45 0 86 -4 93 -8z m121 -107 c18 -54 28 -101 23 -104 -5 -3 -10
-14 -12 -23 -9 -41 -30 5 -49 103 -23 122 -24 132 -7 127 6 -2 27 -49 45 -103z
m-61 -17 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-6 -98 c4 -19
11 -68 14 -107 l7 -73 -56 0 c-45 0 -64 5 -90 25 -17 13 -51 27 -74 31 l-42 7
0 72 c0 39 3 75 7 79 4 3 57 5 117 4 l110 -3 7 -35z m26 -12 c-3 -7 -5 -2 -5
12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m123 -8 c0 -5 -4 -10 -10 -10 -5 0 -10
-9 -10 -20 0 -24 -15 -27 -24 -4 -12 31 -6 44 19 44 14 0 25 -4 25 -10z m594
2 c2 -4 -1 -87 -8 -185 -10 -135 -16 -182 -28 -193 -14 -14 -17 -14 -32 8 -89
124 -106 149 -106 154 0 3 11 3 25 0 21 -5 27 -2 36 21 6 16 17 41 25 56 8 16
14 36 14 45 0 36 33 102 51 102 10 0 20 -3 23 -8z m-1087 -77 c2 -33 5 -74 8
-92 6 -31 7 -32 63 -36 31 -2 -6 -4 -83 -5 -135 -2 -142 -3 -192 -32 -28 -16
-69 -50 -89 -75 -36 -43 -41 -45 -90 -45 -50 0 -53 1 -63 33 -8 24 -8 55 -1
108 19 135 17 132 96 152 114 28 266 55 309 53 l40 -1 2 -60z m433 30 c5 -12
16 -25 24 -28 36 -14 -5 -147 -45 -147 -15 0 -26 40 -34 126 l-7 82 27 -6 c15
-2 30 -14 35 -27z m560 16 c0 -5 -8 -11 -17 -14 -10 -2 -26 -8 -35 -12 -11 -4
-18 -3 -18 4 0 6 15 15 33 20 17 5 33 10 35 10 1 1 2 -3 2 -8z m-386 -51 c34
-15 99 -51 146 -79 46 -28 95 -54 107 -57 24 -6 80 -78 177 -225 46 -70 56
-91 50 -113 -9 -38 -19 -40 -62 -11 -38 25 -40 29 -44 89 -10 114 -67 194
-173 242 -72 33 -120 37 -179 18 -101 -33 -174 -103 -197 -188 -19 -70 -34
-10 -23 92 5 44 10 55 31 65 38 17 63 76 63 147 0 70 -5 69 104 20z m296 15
c0 -8 -1 -15 -3 -15 -1 0 -31 -11 -67 -24 -61 -22 -67 -22 -89 -7 -24 15 -23
16 45 37 84 27 114 29 114 9z m62 -55 l-18 -54 -48 -2 c-59 -4 -121 27 -90 44
11 5 38 15 61 21 23 6 48 18 56 25 11 12 47 25 54 21 2 -1 -5 -26 -15 -55z
m-1416 -2 c-3 -13 -9 -49 -13 -81 -5 -52 -17 -77 -29 -64 -5 5 14 145 22 158
11 19 26 8 20 -13z m784 -107 c0 -5 10 -11 23 -13 16 -2 21 -9 18 -23 -1 -11
-3 -74 -3 -140 1 -111 3 -121 23 -138 12 -10 20 -20 17 -23 -9 -8 -155 -17
-181 -10 -23 5 -25 11 -29 93 -6 112 -25 150 -110 218 l-25 20 41 12 c50 13
226 17 226 4z m1114 -97 c20 -8 21 -38 1 -54 -12 -10 -21 -7 -49 18 -19 17
-32 33 -29 36 8 8 57 8 77 0z m-44 -94 c20 -25 72 -97 114 -160 42 -63 85
-118 94 -122 15 -6 14 -7 -3 -7 -34 -1 -61 25 -121 117 -31 48 -86 125 -123
171 -60 77 -63 83 -32 65 18 -10 50 -39 71 -64z m-1415 56 c97 -41 100 -202 6
-251 -48 -24 -114 -20 -151 11 -61 52 -77 122 -40 182 40 65 113 88 185 58z
m775 -1 c89 -46 104 -159 29 -231 -27 -26 -37 -29 -96 -29 -63 0 -66 1 -99 39
-45 52 -53 96 -25 152 36 75 120 105 191 69z m581 -62 c34 -43 88 -118 121
-168 34 -49 70 -98 82 -108 20 -17 17 -18 -119 -15 -133 3 -143 5 -200 33 -57
29 -60 32 -69 78 -8 41 -6 56 13 100 13 29 28 73 33 99 10 46 19 54 60 57 11
1 42 -30 79 -76z m-1686 30 c-4 -10 -9 -35 -12 -55 -6 -41 -16 -45 -58 -26
-21 9 -25 18 -25 55 l0 43 51 0 c45 0 50 -2 44 -17z m1465 -43 c5 -9 3 -25 -5
-39 l-13 -24 -26 42 c-22 34 -25 45 -15 57 10 13 14 12 31 -3 11 -10 24 -25
28 -33z m396 -53 c57 -80 109 -167 100 -167 -3 0 -38 48 -78 107 -92 136 -91
133 -81 133 4 0 31 -33 59 -73z m-385 -75 c-5 -57 -8 -62 -23 -50 -15 12 -15
17 4 66 11 29 21 52 22 50 1 -2 0 -31 -3 -66z"
        />
        <path
          d="M519 375 c-34 -18 -62 -77 -54 -113 14 -62 68 -96 130 -82 48 11 74
37 81 81 8 47 -9 85 -48 109 -38 23 -73 25 -109 5z m110 -22 c31 -26 42 -73
26 -111 -26 -61 -106 -73 -149 -21 -33 39 -33 79 0 118 20 25 34 31 64 31 21
0 47 -8 59 -17z"
        />
        <path
          d="M541 306 c-16 -19 -11 -46 12 -60 25 -16 52 4 52 40 0 24 -5 30 -26
32 -14 2 -31 -4 -38 -12z m49 -11 c15 -18 5 -35 -21 -35 -12 0 -19 7 -19 18 0
33 20 42 40 17z"
        />
        <path
          d="M1304 381 c-66 -29 -84 -118 -35 -173 26 -29 34 -32 77 -30 64 2 104
42 104 102 0 73 -81 129 -146 101z m107 -40 c20 -20 29 -39 29 -61 0 -44 -47
-90 -92 -90 -66 0 -112 62 -88 120 27 66 101 81 151 31z"
        />
        <path
          d="M1310 301 c-13 -25 -13 -27 6 -45 35 -36 87 0 64 44 -14 26 -56 26
-70 1z m60 -22 c0 -12 -7 -19 -20 -19 -24 0 -38 29 -20 40 19 12 40 1 40 -21z"
        />
      </g>
    </svg>
  );
};

export const Forklift = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 235.000000 120.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,120.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M710 1190 l-175 -5 2 -35 c1 -19 5 -81 9 -136 3 -56 3 -153 -1 -216
l-7 -115 -71 -7 c-329 -28 -307 -22 -307 -83 0 -20 7 -37 19 -45 29 -20 17
-67 -20 -80 l-29 -10 1 -134 c1 -149 5 -160 74 -185 19 -7 40 -27 53 -49 44
-77 169 -111 257 -71 36 16 95 72 95 89 0 4 132 7 293 7 208 1 298 4 314 13
19 10 23 8 41 -22 69 -118 257 -143 377 -52 28 22 33 22 50 9 17 -13 63 -14
330 -8 238 5 313 10 324 20 32 31 2 35 -284 35 l-284 0 2 307 2 307 -39 9 -39
10 4 226 4 226 -158 3 -157 3 -25 -27 c-41 -44 -30 -66 38 -78 36 -7 49 -27
27 -41 -6 -4 -10 -57 -10 -126 0 -109 2 -119 19 -119 16 0 19 -11 24 -97 3
-54 4 -99 2 -101 -2 -2 -12 2 -24 9 -12 8 -33 48 -52 104 -18 49 -48 126 -66
169 -32 75 -33 80 -16 98 11 13 17 36 18 71 0 50 -1 52 -28 55 -16 2 -35 -2
-43 -9 -10 -8 -14 -8 -14 0 0 6 9 16 20 23 11 7 20 23 20 35 0 23 -3 23 -117
24 -65 1 -154 2 -198 3 -44 1 -159 -1 -255 -4z m428 -117 c17 -25 37 -72 108
-261 22 -57 22 -62 6 -53 -10 5 -24 16 -30 24 -7 8 -23 12 -37 9 -25 -4 -25
-3 -14 22 9 20 10 29 1 38 -15 15 -49 -3 -106 -53 -34 -31 -39 -39 -28 -52 7
-8 21 -13 31 -10 23 6 120 -108 157 -183 42 -87 11 -138 -82 -132 l-47 3 -18
55 c-10 30 -28 63 -40 72 -15 13 -22 30 -23 62 -1 25 -5 48 -9 52 -4 4 -46 10
-92 12 -82 4 -85 5 -91 31 -13 60 -48 133 -72 149 -13 9 -40 16 -59 16 l-35 0
7 106 c4 58 9 108 12 113 2 4 103 7 223 7 l219 0 19 -27z m-11 -288 c-4 -8
-17 -15 -29 -15 l-23 1 24 20 c26 21 37 19 28 -6z m-423 -195 c-5 -11 -10 -7
-20 17 -7 17 -18 34 -24 38 -11 7 -14 118 -3 129 10 10 55 -165 47 -184z m516
84 c0 -29 -21 -21 -55 20 -48 59 -36 81 16 30 22 -21 39 -44 39 -50z m14 57
c19 -19 24 -31 16 -36 -6 -4 -12 -5 -13 -3 -1 2 -15 18 -31 36 -38 41 -12 45
28 3z m-691 -193 c-3 -62 -6 -114 -7 -115 -1 -1 -65 -4 -141 -5 -145 -3 -239
7 -200 22 13 5 25 24 33 56 13 46 12 48 -13 68 -50 40 -13 65 99 67 28 0 69 4
91 8 22 5 64 9 92 10 l53 1 -7 -112z m76 105 c16 -4 31 -22 47 -59 26 -59 61
-84 117 -84 49 0 117 -26 150 -58 16 -15 42 -53 58 -84 16 -31 39 -64 51 -72
28 -20 133 -22 147 -4 89 112 149 147 270 155 65 5 81 3 81 -8 0 -11 -12 -13
-51 -10 -71 4 -109 -5 -162 -40 -58 -38 -99 -105 -100 -165 0 -39 -3 -44 -23
-44 -12 0 -24 -4 -26 -9 -2 -6 -116 -13 -259 -17 l-255 -7 -33 94 c-18 52 -39
101 -46 109 -19 22 -28 129 -20 226 7 87 9 89 54 77z m733 -102 l44 -89 -43
-13 c-61 -17 -126 -62 -157 -109 -24 -37 -30 -40 -72 -40 -38 0 -45 3 -40 16
3 9 9 33 12 55 l7 39 63 0 c74 0 99 17 110 75 5 28 1 47 -20 86 -14 28 -23 55
-20 60 3 5 20 9 39 9 32 0 35 -3 77 -89z m100 32 c21 -25 48 -79 48 -98 0 -8
-8 -15 -19 -15 -14 0 -23 13 -34 48 -9 26 -19 56 -23 65 -8 22 9 22 28 0z
m-425 -45 c22 -28 52 -154 45 -183 -13 -47 -28 -40 -61 29 -18 39 -44 75 -65
91 -38 29 -112 55 -157 55 -15 0 -31 5 -34 10 -10 16 260 13 272 -2z m-643
-177 l170 -6 20 -34 19 -33 -43 28 c-35 24 -56 29 -114 32 -59 2 -77 -1 -111
-20 -47 -28 -85 -80 -85 -119 0 -32 -23 -39 -54 -16 -15 11 -19 29 -20 101
l-1 87 25 -6 c14 -4 101 -10 194 -14z m1161 -51 c78 -48 62 -164 -28 -199 -79
-30 -177 28 -177 103 0 96 117 150 205 96z m-1122 -47 c-7 -2 -19 -2 -25 0 -7
3 -2 5 12 5 14 0 19 -2 13 -5z m78 -22 c19 -20 29 -39 28 -58 l-1 -28 -7 31
c-11 43 -19 54 -55 70 -20 8 -24 13 -13 14 10 0 32 -13 48 -29z m-23 -7 c15
-10 22 -25 22 -47 0 -38 -7 -50 -37 -66 -74 -39 -151 51 -93 109 24 24 77 26
108 4z m-123 -104 l20 -25 -22 19 c-13 11 -23 24 -23 29 0 6 1 8 3 6 1 -2 11
-15 22 -29z m130 -20 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z
m-42 -17 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z"
        />
        <path
          d="M1414 300 c-30 -12 -64 -58 -64 -86 0 -63 50 -104 125 -104 38 0 52
5 76 29 31 31 39 83 19 122 -22 41 -102 61 -156 39z m106 -15 c39 -20 53 -49
46 -91 -8 -42 -48 -74 -93 -74 -40 0 -88 23 -97 45 -34 90 56 165 144 120z"
        />
        <path
          d="M1432 244 c-27 -18 -28 -45 -4 -67 34 -31 92 -14 92 28 0 23 -32 55
-55 55 -6 0 -21 -7 -33 -16z m67 -18 c25 -30 -24 -71 -54 -46 -16 13 -20 42
-8 53 11 12 50 8 62 -7z"
        />
        <path
          d="M390 195 c-15 -18 -4 -52 20 -60 28 -9 60 12 60 39 0 36 -56 50 -80
21z m60 -10 c16 -19 4 -35 -26 -35 -17 0 -24 6 -24 18 0 34 28 43 50 17z"
        />
      </g>
    </svg>
  );
};

export const Email = ({ width, height, color }: IconsPropsType) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 16 16">
      <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
    </svg>
  );
};
